<template>
  <v-container grid-list-md class="py-0 px-2 ma-0">
    <v-row>
      <v-col cols="12" class="pt-0">
        <v-card flat v-if="lAction === 'view'">
          <v-card-title class="px-0">
            <v-layout row wrap>
              <v-flex xs7>
                <v-text-field
                class="pa-0 mt-1"
                append-icon="mdi-account-search-outline"
                :placeholder="$vuetify.breakpoint.smAndUp?'Search project name':'Search'"
                single-line
                hide-details
                v-model="search"
                @input="searchProjectTile(search)"
                outlined
                clearable
                ></v-text-field>
              </v-flex>
              <v-flex xs2 class="text-right pt-4">
                <v-chip :class="isClosedProject ? 'info dark' : '' " @click="showClosedProjects()">Show Closed Projects</v-chip>
              </v-flex>
              <v-flex xs3>
                <v-download-as
                class="pa-0 mt-3"
                :headers="activeProjectApprovedContractExportHeader"
                :items="activeProjectApprovedContractExport"
                title="All Active Approved Contracts"
                :landscape="true"
                ></v-download-as>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-text class="pa-0">
            <v-expansion-panels v-if="projTitle.length > 0" :value="selTab">
              <v-expansion-panel v-for="(proj, i) in projTitle" :key="i">
                <v-expansion-panel-header class="py-0">
                  <div class="subtitle">{{ proj }}</div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-data-table
                  :headers="projContHead"
                  hide-default-header
                  :items="projContractList.filter(rec => rec.proj_name === proj)"
                  hide-default-footer
                  disable-pagination
                  :mobile-breakpoint="0"
                  class="elevation-1">
                  <template v-slot:header="{ props: { headers } }">
                    <thead>
                      <tr>
                        <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: left;">{{headers[0].text}}</th>
                        <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 90px; text-align: left;">{{headers[1].text}}</th>
                        <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 110px; text-align: left;">{{headers[2].text}}</th>
                        <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 110px; text-align: left;">{{headers[3].text}}</th>
                        <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 130px; text-align: right;">{{headers[4].text}}</th>
                        <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: right;">{{headers[5].text}}</th>
                        <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: right;">{{headers[6].text}}</th>
                        <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: right;">{{headers[7].text}}</th>
                        <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: right;">{{headers[8].text}}</th>
                      </tr>
                    </thead>
                  </template>
                  <template slot="item" slot-scope="props">
                    <tr @click="prepareUpdate(props.item)" :class="props.item.proj_status === 'Closed' ? 'grey--text' : ''">
                      <td style="font-size: 12px;">{{ 'Version ' + props.item.version }}</td>
                      <td style="font-size: 12px;">{{ props.item.status }}</td>
                      <td style="font-size: 12px;">{{ props.item.contract_start_date ? handy.formatDate(props.item.contract_start_date) : '-' }}</td>
                      <td style="font-size: 12px;">{{ props.item.contract_end_date ? handy.formatDate(props.item.contract_end_date) : '-' }}</td>
                      <td style="font-size: 12px;" class="text-right">{{ props.item.total_hc_value ? handy.formatCur(props.item.total_hc_value) : '-' }}</td>
                      <td style="font-size: 12px;" class="text-right">{{ props.item.mgmt_fee ? handy.formatCur(props.item.mgmt_fee) : '-' }}</td>
                      <td style="font-size: 12px;" class="text-right">{{ props.item.total_value ? handy.formatCur(props.item.total_value) : '-' }}</td>
                      <td style="font-size: 12px;" class="text-right">{{ props.item.gst_amt ? handy.formatCur(props.item.gst_amt) : '-' }}</td>
                      <td style="font-size: 12px;" class="text-right">{{ props.item.contract_amt_with_tax ? handy.formatCur(props.item.contract_amt_with_tax) : '-' }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-flex xs12 v-else>
            <div style="font-size: 15px; text-align: center; color: #FFAB40;">
              No active project contract
            </div>
          </v-flex>
        </v-card-text>
      </v-card>

      <v-btn
      :style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:20px; right:15px;':'bottom:15px; right:15px;')"
      dark fab fixed color="accent" v-if="lAction === 'view'"
      @click.native="prepareCreate"><v-icon>mdi-plus</v-icon></v-btn>

      <!-- 1. create, update and delete of project contract -->
      <v-container v-if="lAction === 'create' || lAction === 'update'" class="pa-0" fluid full-height>
        <v-layout row wrap>
          <v-flex xs12 class="mt-2">
            <v-form ref="pForm" @submit.prevent="saveProjectContractBaseChanges(lAction)">
              <v-card>
                <v-card-title class="py-2 grey lighten-4">
                  <v-btn small icon @click="lAction = 'view'"><v-icon>mdi-arrow-left</v-icon></v-btn>
                  <span class="pl-2 primary--text">{{ handy.startWithUpper(lAction) + ' Project Contract' }}</span>
                </v-card-title>
                <v-card-text>
                  <v-flex xs12>
                    <v-layout row wrap>
                      <v-flex xs4>
                        <v-combobox
                        v-model="lProjContractBase.proj_pair"
                        :items="projList"
                        item-text="proj_name"
                        item-value="proj_id"
                        label="Project"
                        hide-details
                        :disabled="lAction === 'update'"
                        @input="loadZoneBasedOnPorjId(lProjContractBase)"
                        ></v-combobox>
                      </v-flex>
                      <v-flex xs4>
                        <v-select
                        v-model="lProjContractBase.zone_id"
                        :items="zoneList"
                        item-text="zone_name"
                        item-value="zone_id"
                        label="Zone"
                        :disabled="lAction === 'update'"
                        hide-details
                        ></v-select>
                      </v-flex>
                      <v-flex xs4 class="text-right pt-4">
                        <v-btn class="mr-3" @click="deleteProjectContract(lProjContractBase)" v-if="projContractDetList.length === 0 && projContractServiceDetList.length === 0 && lAction === 'update'">delete</v-btn>
                        <v-btn class="accent" type="submit" :disabled="versionList.length > 0">save</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-card-text>
              </v-card>
            </v-form>
          </v-flex>
          <v-flex xs12 v-if="lProjContractBase.proj_contract_base_id">
            <v-card>
              <v-card-title class="py-2 pl-2 grey lighten-4">
                <v-flex xs12>
                  <v-layout row wrap>
                    <v-flex xs4>
                      <v-chip @click="chooseToViewProjDet('Manpower details')" :style="lProjContract.det === 'Manpower details' ? 'background-color: #4EA9D0; color: #fff;' : ''" class="mr-2">Manpower details ({{lProjContract.tot_hc ? lProjContract.tot_hc.toFixed(2) : 0}})</v-chip>
                      <v-chip @click="chooseToViewProjDet('Service details')" :style="lProjContract.det === 'Service details' ? 'background-color: #4EA9D0; color: #fff;' : ''">Service details</v-chip>
                    </v-flex>
                    <v-flex xs6 class="text-center">
                      <span style="color: #000; font-size: 12px; font-weight:bold;">Current Status:  </span>
                      <v-chip :disabled="isClosedProject" style="font-weight:bold;" small color="tertiary white--text">{{lStatus}}</v-chip>
                      <span class="ml-3" style="color: #000; font-size: 12px; font-weight:bold;">Selected Version:  </span>
                      <v-chip :disabled="isClosedProject" style="font-weight:bold;" small color="green white--text">{{'Ver ' + lVersion + '.0'}}</v-chip>
                    </v-flex>
                    <v-flex xs2 class="text-right">
                      <v-btn :disabled="(lStatus !== 'Draft' &&  config.ROLE_NAME != 'Finance Super Admin') || isClosedProject" @click="prepareProjContractDet(lProjContract.proj_contract_base_id)" icon><v-icon>mdi-playlist-plus</v-icon></v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-card-title>
              <v-card-text class="pa-0">
                <v-flex xs12>
                  <v-layout row wrap>
                    <v-flex xs12 sm9 class="pa-0">
                      <v-flex xs12 v-if="lProjContract.det === 'Manpower details'">
                        <v-data-table
                        :headers="detHeaders"
                        :items="projContractDetList"
                        hide-default-footer
                        disable-sort
                        fixed-header
                        dense
                        height="310px"
                        disable-pagination
                        >
                        <template slot="item" slot-scope="props">
                          <v-menu
                          absolute
                          offset-y
                          >
                          <template v-slot:activator="{ on }">
                            <tr v-on="on" v-if="props.index !== projContractDetList.length - 1">
                              <td style="font-size: 12px;">{{ props.index + 1 }}</td>
                              <td style="font-size: 12px;">{{ props.item.staff_role }}</td>
                              <td style="font-size: 12px;">{{ props.item.head_count }}</td>
                              <td style="font-size: 12px;" class="text-right">{{ handy.formatCur(props.item.amt_per_hc) }}</td>
                              <td style="font-size: 12px;">{{ props.item.work_hrs ? props.item.work_hrs : '-' }}</td>
                              <td style="font-size: 12px;" class="text-right">{{ handy.formatCur(props.item.total_hc_amt) }}</td>
                              <td style="font-size: 12px;">{{ props.item.contract_start_date ? handy.formatDate(props.item.contract_start_date) : '-' }}</td>
                              <td style="font-size: 12px;">{{ props.item.contract_end_date ? handy.formatDate(props.item.contract_end_date) : '-' }}</td>
                              <td style="font-size: 12px;">{{ props.item.Mgmt_fee_per }}</td>
                              <td style="font-size: 12px;" class="text-right">{{ handy.formatCur(props.item.Mgmt_fee_amt) }}</td>
                              <td style="font-size: 12px;">{{ props.item.is_igst ? 'IGST' : 'GST' }}</td>
                              <td style="font-size: 12px;">{{ props.item.igst_per + props.item.cgst_per + props.item.sgst_per }}</td>
                              <td style="font-size: 12px;" class="text-right">{{ handy.formatCur(props.item.igst_amt + props.item.cgst_amt + props.item.sgst_amt) }}</td>
                              <td style="font-size: 12px;" class="text-right">{{ handy.formatCur(props.item.total_amt) }}</td>
                              <td style="font-size: 12px;">{{ props.item.is_os === 0 ? 'No' : 'Yes' }}</td>
                            </tr>
                          </template>
                          <!-- list of menuitems -->
                          <v-list>
                            <v-list-item :disabled="isClosedProject || (config.ROLE_NAME != 'Finance Super Admin' && lStatus != 'Draft')" @click="prepareUpdateProjContractDet(props.item)">
                              <v-list-item-avatar><v-icon :disabled="isClosedProject || (lStatus != 'Draft' && config.ROLE_NAME != 'Finance Super Admin')">mdi-pencil</v-icon></v-list-item-avatar>
                              <v-list-item-title>Edit</v-list-item-title>
                            </v-list-item>
                            <v-list-item :disabled="isClosedProject || (lStatus != 'Draft' && config.ROLE_NAME != 'Finance Super Admin')" @click="prepareCloneProjectContract(props.item)">
                              <v-list-item-avatar><v-icon :disabled="isClosedProject || (lStatus != 'Draft' && config.ROLE_NAME != 'Finance Super Admin')">mdi-content-copy</v-icon></v-list-item-avatar>
                              <v-list-item-title>Clone</v-list-item-title>
                            </v-list-item>
                            <v-list-item :disabled="isClosedProject || (lStatus != 'Draft' && config.ROLE_NAME != 'Finance Super Admin')" @click="deleteDetail(props.item)">
                              <v-list-item-avatar><v-icon :disabled="isClosedProject || (lStatus != 'Draft' && config.ROLE_NAME != 'Finance Super Admin')">mdi-delete</v-icon></v-list-item-avatar>
                              <v-list-item-title>Delete</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="viewStaffDetail(props.item)">
                              <v-list-item-avatar><v-icon>mdi-book-open-blank-variant</v-icon></v-list-item-avatar>
                              <v-list-item-title>View</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </template>
                      <template slot="body.append">
                        <tr class="orange lighten-3">
                          <td colspan="5">
                            <strong>Total</strong>
                          </td>
                          <td :class="totalContractAmt.tot_hc_amt === 0 ? 'text-right' : 'pl-0 text-right'">
                            <strong>{{ handy.formatCur(totalContractAmt.tot_hc_amt) }}</strong>
                          </td>
                          <td colspan="3"></td>
                          <td :class="totalContractAmt.tot_hc_amt === 0 ? 'text-right' : 'pl-0 text-right'">
                            <strong>{{ handy.formatCur(totalContractAmt.man_mgmt_fee) }}</strong>
                          </td>
                          <td colspan="2"></td>
                          <td class="text-right">
                            <strong>{{ handy.formatCur(totalContractAmt.man_gst_amt) }}</strong>
                          </td>
                          <td :class="totalContractAmt.tot_hc_amt === 0 ? 'text-right' : 'pl-0 text-right'">
                            <strong>{{ handy.formatCur(totalContractAmt.tot_man_grand_total) }}</strong>
                          </td>
                          <td></td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-flex>
                  <v-flex xs12 v-else>
                    <v-data-table
                    :headers="serviceDetHeaders"
                    :items="projContractServiceDetList"
                    hide-default-footer
                    fixed-header
                    height="310px"
                    disable-sort
                    dense
                    disable-pagination
                    :mobile-break-point="0"
                    >
                    <template slot="item" slot-scope="props">
                      <v-menu
                      absolute
                      offset-y
                      >
                      <template v-slot:activator="{ on }">
                        <tr v-on="on" v-if="props.index !== projContractServiceDetList.length - 1">
                          <td style="font-size: 12px;">{{ props.index + 1 }}</td>
                          <td style="font-size: 12px;">{{ props.item.proj_contract_category + ' - ' + props.item.proj_contract_sub_category }}</td>
                          <td style="font-size: 12px;" class="text-right">{{ handy.formatCur(props.item.amount) }}</td>
                          <td style="font-size: 12px;">{{ props.item.contract_start_date ? handy.formatDate(props.item.contract_start_date) : '-' }}</td>
                          <td style="font-size: 12px;">{{ props.item.contract_end_date ? handy.formatDate(props.item.contract_end_date) : '-' }}</td>
                          <td style="font-size: 12px;">{{ props.item.Mgmt_fee_per }}</td>
                          <td style="font-size: 12px;" class="text-right">{{ handy.formatCur(props.item.Mgmt_fee_amt) }}</td>
                          <td style="font-size: 12px;">{{ props.item.is_igst ? 'IGST' : 'GST' }}</td>
                          <td style="font-size: 12px;">{{ props.item.is_igst ? props.item.igst_per : props.item.cgst_per + props.item.sgst_per }}</td>
                          <td style="font-size: 12px;" class="text-right">{{ props.item.is_igst ? handy.formatCur(props.item.igst_amt) : handy.formatCur(props.item.cgst_amt + props.item.sgst_amt) }}</td>
                          <td style="font-size: 12px;" class="text-right">{{ handy.formatCur(props.item.total_amt) }}</td>
                          <td style="font-size: 12px;">{{ props.item.is_monthly_rental === 0 ? 'No' : 'Yes' }}</td>
                          <td style="font-size: 12px;">{{ props.item.is_os === 1 ? 'Yes' : 'No' }}</td>
                        </tr>
                      </template>
                      <!-- menu -->
                      <v-list>
                        <v-list-item :disabled="isClosedProject || (lStatus != 'Draft' && config.ROLE_NAME != 'Finance Super Admin')" @click="prepareUpdateProjContractServiceDet(props.item)">
                          <v-list-item-avatar><v-icon :disabled="isClosedProject || (lStatus != 'Draft' && config.ROLE_NAME != 'Finance Super Admin')">mdi-pencil</v-icon></v-list-item-avatar>
                          <v-list-item-title>Edit</v-list-item-title>
                        </v-list-item>
                        <v-list-item :disabled="isClosedProject || (lStatus != 'Draft' && config.ROLE_NAME != 'Finance Super Admin')" @click="prepareCloneProjectContractService(props.item)">
                          <v-list-item-avatar><v-icon :disabled="isClosedProject || (lStatus != 'Draft' && config.ROLE_NAME != 'Finance Super Admin')">mdi-content-copy</v-icon></v-list-item-avatar>
                          <v-list-item-title>Clone</v-list-item-title>
                        </v-list-item>
                        <v-list-item :disabled="isClosedProject || (lStatus != 'Draft' && config.ROLE_NAME != 'Finance Super Admin')" @click="deleteServiceDetail(props.item)">
                          <v-list-item-avatar><v-icon :disabled="isClosedProject || (lStatus != 'Draft' && config.ROLE_NAME != 'Finance Super Admin')">mdi-delete</v-icon></v-list-item-avatar>
                          <v-list-item-title>Delete</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="viewServiceDetail(props.item)">
                          <v-list-item-avatar><v-icon>mdi-book-open-blank-variant</v-icon></v-list-item-avatar>
                          <v-list-item-title>View</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </template>
                  <template slot="body.append">
                    <tr class="orange lighten-3">
                      <td colspan="2">
                        <strong>Total</strong>
                      </td>
                      <td :class="totalContractAmt.tot_hc_amt === 0 ? 'text-right' : 'pl-0 text-right'">
                        <strong>{{ handy.formatCur(totalContractAmt.amount) }}</strong>
                      </td>
                      <td colspan="3"></td>
                      <td :class="totalContractAmt.tot_hc_amt === 0 ? 'text-right' : 'pl-0 text-right'">
                        <strong>{{ handy.formatCur(totalContractAmt.mgmt_fee) }}</strong>
                      </td>
                      <td colspan="2"></td>
                      <td class="text-right">
                        <strong>{{ handy.formatCur(totalContractAmt.gst_amt) }}</strong>
                      </td>
                      <td :class="totalContractAmt.tot_hc_amt === 0 ? 'text-right' : 'pl-0 text-right'">
                        <strong>{{ handy.formatCur(totalContractAmt.tot_ser_grand_total) }}</strong>
                      </td>
                      <td colspan="2"></td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-flex>
            <v-flex xs12 sm3>
              <v-data-table
              :headers="detHistory"
              :items="versionList"
              hide-default-footer
              disable-sort
              disable-pagination
              dense
              fixed-header
              height="310px"
              :mobile-break-point="0">
              <template slot="item" slot-scope="props">
                <tr @click="loadManPowerBasedOnVersion(props.item)" :class="lVersion === props.item.version ? 'warning lighten-5' : 'tertiary--text'" style="font-weight: bold; cursor: pointer;">
                  <td style="font-size: 12px; padding:7px 8px;">{{ (props.item.version ? 'Ver ' + props.item.version + '.0' : 'Version 1.0') }} <span :class="props.item.status === 'Submitted' ? 'orange--text' : props.item.status === 'Approved' ? 'green--text' : 'red--text'">{{'(' + props.item.status + ')'}}</span></td>
                  <td style="font-size: 12px; padding:7px 8px;">{{ handy.formatCur(props.item.contract_value_with_gst) }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-card-text>
    <v-card-actions class="pt-0 px-1">
      <v-flex xs12 class="pa-0">
        <v-flex xs12>
          <v-alert border="top" colored-border color="info" elevation="2" class="grey lighten-4 mt-2 mb-0">
            <v-flex xs12>
              <v-layout row wrap>
                <table width="100%" cellpadding="0" cellspacing="0">
                  <tr>
                    <td class="subheading" style="width: 233px;">
                      <v-chip small :disabled="isClosedProject" style="background-color:#4EA9D0; font-size: 12px; color:#fff;">Manpower Total (+ GST): &nbsp;<span style="font-weight: bold;">{{ handy.formatCur(totalContractAmt.tot_man_grand_total) || 0 }}</span></v-chip>
                    </td>
                    <td class="subheading pl-1" style="width: 233px;">
                      <v-chip small :disabled="isClosedProject" style="background-color:#4EA9D0; font-size: 12px; color:#fff;">Service Total (+ GST): &nbsp;<span style="font-weight: bold;">{{ handy.formatCur(totalContractAmt.tot_ser_grand_total) || 0 }}</span></v-chip>
                    </td>
                    <td class="subheading py-2 pl-1" style="width: 233px;">
                      <v-chip small :disabled="isClosedProject" style="background-color: #4EA9D0; font-size: 12px; color:#fff;">Contract Value: &nbsp; <span style="font-weight: bold;">{{ handy.formatCur(totalContractAmt.tot_man_contract_amt + totalContractAmt.tot_contract_amt) || 0}}</span> </v-chip>
                    </td>
                    <td class="subheading pl-1" style="width: 190px;">
                      <v-chip small :disabled="isClosedProject" style="background-color:#4EA9D0; font-size: 12px; color:#fff;">GST: &nbsp;<span style="font-weight: bold;">{{ handy.formatCur(totalContractAmt.gst_amt + totalContractAmt.man_gst_amt) || 0 }}</span></v-chip>
                    </td>
                    <td class="subheading pl-1" colspan="100%">
                      <v-chip small :disabled="isClosedProject" style="background-color:#4EA9D0; font-size: 12px; color:#fff;">Contract Value (+ GST): &nbsp;<span style="font-weight: bold;">{{ handy.formatCur(totalContractAmt.tot_contract_amt_with_gst) || 0 }}</span></v-chip>
                    </td>
                  </tr>
                </table>
              </v-layout>
            </v-flex>
          </v-alert>
        </v-flex>
        <v-layout row wrap>
          <v-flex xs12>
            <v-alert border="top" colored-border color="info" elevation="2" class="grey lighten-4 mt-2 px-2 mx-1 mb-0">
              <v-flex xs12>
                <v-layout row wrap>
                  <v-flex xs11 style="font-size: 12px; color: #000;">
                    <input style="display:none" type="file" ref="fileInput"
                    accept=".xls, .xlsx, .pdf, .doc, .docx, image/png, image/gif, image/jpeg" multiple @change="loadFilesFromFileBrowser(lProjContract)"/>
                    <v-btn :disabled="lStatus !== 'Draft' && config.ROLE_NAME != 'Finance Super Admin'" icon @click="pickFile"><v-icon>mdi-attachment</v-icon></v-btn>
                    <span v-if="lProjContract.files && lProjContract.files.filter(rec => rec.is_selected).length > 0">
                      <span v-for="(file, index) in lProjContract.files.filter(rec => rec.is_selected)" :key="index">
                        <v-chip style="font-size: 12px;" v-model="file.is_selected" @click:close="removeSelectedFile(file)" @input="$forceUpdate()" close>{{ file.file_name }}</v-chip>
                      </span>
                    </span>
                    <span v-else>Attachment if any<br /><span class="caption">(supports images, pdfs, docs and excels upto 20MB)</span></span>
                  </v-flex>
                  <v-flex xs1 class="text-right pr-0">
                    <v-btn class="info" :disabled="lStatus !== 'Draft' && config.ROLE_NAME != 'Finance Super Admin'" @click="saveProjectContractAttachment()">save</v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-alert>
          </v-flex>
        </v-layout>
        <v-alert border="top" colored-border color="info" elevation="2" class="grey lighten-4 mt-2 px-2 mx-1 mb-0">
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex xs6 class="pt-0">
                <v-alert text dense class="grey lighten-4 mb-0 pl-1">
                  <v-layout row wrap>
                    <v-flex xs1>
                      <v-btn style="height: 0px;" @click="showTimelineInfo = true" icon><v-icon>mdi-information-outline</v-icon></v-btn>
                    </v-flex>
                    <v-flex xs11>
                      <div style="font-size: 12px; color: #000;">Created By: {{lProjContract.update_by}} on {{handy.formatDate(lProjContract.updated_date) + ' ' + handy.getTime12Hrs(lProjContract.updated_date)}}</div>
                      <div style="font-size: 12px; color: #000;" v-if="lStatus === 'Submitted' || lStatus === 'Approved' || lStatus === 'Obsolete Approved' || lProjContract.drafted_by_name || (lProjContract.submitted_by_name && lProjContract.rejected_date)">Submitted By: {{lProjContract.submitted_by_name}} on {{handy.formatDate(lProjContract.submitted_date) + ' ' + handy.getTime12Hrs(lProjContract.submitted_date)}}</div>
                      <div style="font-size: 12px; color: #000;" v-if="lStatus === 'Approved' || lStatus === 'Obsolete Approved' || lProjContract.drafted_by_name">Approved By: {{lProjContract.approved_by_name}} on {{handy.formatDate(lProjContract.approved_date) + ' ' + handy.getTime12Hrs(lProjContract.approved_date)}}</div>
                      <div style="font-size: 12px; color: #000;" v-if="(lStatus === 'Draft' || lProjContract.drafted_by_name) && lProjContract.submitted_by_name && lProjContract.rejected_date">Rejected By: {{lProjContract.rejected_by_name}} on {{handy.formatDate(lProjContract.rejected_date) + ' ' + handy.getTime12Hrs(lProjContract.rejected_date)}}</div>
                      <div style="font-size: 12px; color: #000;" v-if="lStatus === 'Draft' && lProjContract.drafted_by_name && lProjContract.drafted_date">Drafted By Finance Super Admin: {{lProjContract.drafted_by_name}} on {{handy.formatDate(lProjContract.drafted_date) + ' ' + handy.getTime12Hrs(lProjContract.drafted_date)}}</div>
                    </v-flex>
                  </v-layout>
                </v-alert>
              </v-flex>
              <v-flex xs6 class="text-right pr-0 pt-0">
                <v-btn small :disabled="isClosedProject" v-if="lStatus === 'Submitted'" @click="prepareProjectContractStatus(lProjContractBase, 'Approved')">Approve</v-btn>
                <v-btn small :disabled="isClosedProject" v-if="lStatus === 'Submitted'" @click="prepareProjectContractStatus(lProjContractBase, 'Rejected')">Reject</v-btn>
                <v-btn small :disabled="(projContractDetList.length === 0 && projContractServiceDetList.length === 0) || isClosedProject" v-if="lStatus === 'Draft'" @click="prepareProjectContractStatus(lProjContractBase, 'Submitted')">submit</v-btn>
                <v-btn small :disabled="isClosedProject" v-if="lStatus === 'Approved' || lStatus === 'Absolute Approved'" @click="prepareRevision(lProjContract)">create revision</v-btn>
                <v-btn small :disabled="isClosedProject" v-if="(lStatus === 'Approved' || lStatus === 'Obsolete Approved') && config.ROLE_NAME === 'Finance Super Admin'" @click="prepareProjectContractStatus(lProjContractBase, 'Draft')">convert as draft</v-btn>
                <v-btn small @click="prepareViewProjContract(lProjContract)">view</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-alert>
      </v-flex>
    </v-card-actions>
  </v-card>
</v-flex>
</v-layout>
</v-container>

<!-- 2. insert/update/delete the manpower/service details -->
<v-dialog v-model="showDet" persistent scrollable max-width="500px">
  <v-flex xs12>
    <v-card>
      <v-card-title class="py-2 grey lighten-4">
        {{lProjContractDet.action}} Details
        <v-spacer></v-spacer>
        <v-btn icon small @click="showDet = false"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text class="px-4 py-2">
        <v-flex xs12 class="px-2">
          <v-layout row wrap>
            <v-flex xs12>
              <v-combobox
              v-model="lProjContractDet.proj_contract_category_pair"
              :items="catList"
              item-text="proj_contract_category"
              label="Category"
              hide-details
              :disabled="lProjContractDet.action === 'View'"
              @input="loadRolesorSubCatBasedOnCat(lProjContractDet.proj_contract_category_pair)"
              :rules="[rules.required]"
              ></v-combobox>
            </v-flex>
            <v-flex xs12 class="pt-1 px-2" v-if="lProjContractDet.proj_contract_category_pair && lProjContractDet.proj_contract_category_pair.proj_contract_category_id === null">
              <v-form ref="dForm" @submit.prevent="saveStaffDetail(lProjContractDet.action)">
                <v-card flat>
                  <v-card-text class="pa-0">
                    <v-flex xs12>
                      <v-layout row wrap>
                        <v-flex xs6 class="px-2">
                          <v-select
                          v-model="lProjContractDet.role_id"
                          :items="roleList"
                          item-text="staff_role"
                          item-value="staff_role_id"
                          label="Role Name"
                          hide-details
                          :disabled="lProjContractDet.action === 'Update' || lProjContractDet.action === 'View'"
                          :rules="[rules.required]"
                          ></v-select>
                        </v-flex>
                        <v-flex xs6 class="px-2">
                          <v-text-field
                          v-model="lProjContractDet.head_count"
                          label="Total Head Count"
                          type="number"
                          hide-details
                          :rules="[rules.required]"
                          :disabled="lProjContractDet.action === 'View'"
                          @input="calculateTotalHeadCountAmt()"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6 class="px-2">
                          <v-text-field
                          v-model="lProjContractDet.amt_per_hc"
                          label="HC Cost Per Head"
                          type="number"
                          hide-details
                          :rules="[rules.required]"
                          :disabled="lProjContractDet.action === 'View'"
                          @input="calculateTotalHeadCountAmt()"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6 class="px-2">
                          <v-text-field
                          v-model="lProjContractDet.total_hc_amt"
                          label="Total"
                          type="number"
                          hide-details
                          disabled
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6 class="px-2">
                          <v-text-field
                          v-model="lProjContractDet.work_hrs"
                          label="Work Hours"
                          type="number"
                          hide-details
                          :disabled="lProjContractDet.action === 'View'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6 class="px-2">
                          <v-checkbox hide-details
                          label="Is Outsourced"
                          :disabled="lProjContractDet.action === 'View'"
                          v-model="lProjContractDet.is_os"></v-checkbox>
                        </v-flex>
                        <v-flex xs6 class="px-2">
                          <v-dialog ref="dlgPeriodFrom"
                          persistent v-model="dlgPeriodFrom"
                          max-width="290px"
                          :return-value.sync="lProjContractDet.contract_start_date"
                          >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                            slot="activator" label="Contract Start Date"
                            :rules="[rules.required]"
                            v-model="lProjContractDet.contract_start_date" append-icon="mdi-calendar-today"
                            readonly clearable hide-details
                            v-on="on"
                            :disabled="lProjContractDet.action === 'View'"
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="lProjContractDet.contract_start_date" scrollable
                          first-day-of-week="1"
                          :disabled="lProjContractDet.action === 'View'"
                          >
                          <v-spacer></v-spacer>
                          <v-btn text @click="dlgPeriodFrom = false">Cancel</v-btn>
                          <v-btn text color="accent" @click="$refs.dlgPeriodFrom.save(lProjContractDet.contract_start_date)">OK</v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-flex>
                    <v-flex xs6 class="px-2">
                      <v-dialog ref="dlgPeriodTo"
                      persistent v-model="dlgPeriodTo"
                      max-width="290px"
                      :return-value.sync="lProjContractDet.contract_end_date"
                      >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                        slot="activator" label="Contract End Date"
                        :rules="[rules.required]"
                        v-model="lProjContractDet.contract_end_date" append-icon="mdi-calendar-today"
                        readonly clearable hide-details
                        v-on="on"
                        :disabled="lProjContractDet.action === 'View'"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="lProjContractDet.contract_end_date" scrollable
                      first-day-of-week="1"
                      :disabled="lProjContractDet.action === 'View'"
                      >
                      <v-spacer></v-spacer>
                      <v-btn text @click="dlgPeriodTo = false">Cancel</v-btn>
                      <v-btn text color="accent" @click="$refs.dlgPeriodTo.save(lProjContractDet.contract_end_date)">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-flex>
                <v-flex xs6 class="px-2">
                  <v-text-field
                  v-model="lProjContractDet.Mgmt_fee_per"
                  label="Mgmt %"
                  type="number"
                  hide-details
                  :disabled="lProjContractDet.action === 'View'"
                  @input="calculateTotalmgmtAmt()"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 class="px-2">
                  <v-text-field
                  v-model="lProjContractDet.Mgmt_fee_amt"
                  label="Mgmt Fee"
                  type="number"
                  disabled
                  hide-details
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 class="px-2">
                  <v-radio-group :disabled="lProjContractDet.action === 'View'" v-model="lProjContractDet.is_igst" :mandatory="true" row class="pt-0" hide-details>
                    <v-radio label="CGST/SGST" value="0"></v-radio>
                    <v-radio label="IGST" value="1"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs6 class="px-2">
                  <v-layout row wrap>
                    <v-flex xs6 class="px-2">
                      <v-text-field
                      v-model="lProjContractDet.igst_per"
                      label="IGST %"
                      type="number"
                      hide-details
                      :disabled="lProjContractDet.is_igst === '1' && lProjContractDet.action !== 'View' ? false : true"
                      @input="calculateTotalmgmtAmt()"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6 class="px-2">
                      <v-text-field
                      v-model="lProjContractDet.igst_amt"
                      label="IGST Fee"
                      type="number"
                      hide-details
                      disabled
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 class="px-2">
                  <v-layout row wrap>
                    <v-flex xs3 class="px-2">
                      <v-text-field
                      v-model="lProjContractDet.cgst_per"
                      label="CGST %"
                      type="number"
                      hide-details
                      :disabled="lProjContractDet.is_igst === '1' || lProjContractDet.action === 'View' ? true : false"
                      @input="calculateTotalmgmtAmt()"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs3 class="px-2">
                      <v-text-field
                      v-model="lProjContractDet.cgst_amt"
                      label="CGST Fee"
                      type="number"
                      hide-details
                      disabled
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs3 class="px-2">
                      <v-text-field
                      v-model="lProjContractDet.sgst_per"
                      label="SGST %"
                      type="number"
                      hide-details
                      :disabled="lProjContractDet.is_igst === '1' || lProjContractDet.action === 'View' ? true : false"
                      @input="calculateTotalmgmtAmt()"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs3 class="px-2">
                      <v-text-field
                      v-model="lProjContractDet.sgst_amt"
                      label="SGST Fee"
                      type="number"
                      hide-details
                      disabled
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 class="px-2">
                  <v-text-field
                  v-model="lProjContractDet.total_amt"
                  label="Total"
                  type="number"
                  disabled
                  hide-details
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 class="px-2">
                  <v-textarea
                  v-model="lProjContractDet.comments"
                  label="If any Comments"
                  hide-details
                  rows="2"
                  :disabled="lProjContractDet.action === 'View'"
                  maxlength="500"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-card-text>
          <v-card-actions class="px-4 pb-4">
            <v-spacer></v-spacer>
            <v-btn @click="showDet = false">cancel</v-btn>
            <v-btn :disabled="lProjContractDet.action === 'View'" type="submit" class="accent">save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
    <v-flex xs12 class="pt-1 px-2" v-if="lProjContractDet.proj_contract_category_pair && lProjContractDet.proj_contract_category_pair.proj_contract_category_id">
      <v-form ref="sForm" @submit.prevent="saveServiceDetail(lProjContractServiceDet.action)">
        <v-card flat>
          <v-card-text class="pa-0">
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs10 class="px-2">
                  <v-select
                  v-model="lProjContractServiceDet.proj_contract_sub_cat_id"
                  :items="subcatList"
                  item-text="proj_contract_sub_category"
                  item-value="proj_contract_sub_category_id"
                  label="Sub-Category"
                  hide-details
                  :disabled="lProjContractDet.action === 'Update' || lProjContractServiceDet.action === 'view'"
                  :rules="[rules.required]"
                  ></v-select>
                </v-flex>
                <v-flex xs2 class="pt-4 text-right">
                  <v-btn fab small :disabled="lProjContractServiceDet.action === 'view'" @click="prepareSubCat(lProjContractDet.proj_contract_category_pair.proj_contract_category_id)"><v-icon>mdi-plus</v-icon></v-btn>
                </v-flex>
                <v-flex xs12 class="px-2">
                  <v-text-field
                  v-model="lProjContractServiceDet.amount"
                  label="Total"
                  type="number"
                  hide-details
                  @input="calculateTotalmgmtAmt()"
                  :disabled="lProjContractServiceDet.action === 'view'"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 class="px-2">
                  <v-checkbox hide-details
                  label="Is Outsourced"
                  :disabled="lProjContractServiceDet.action === 'view'"
                  v-model="lProjContractServiceDet.is_os"></v-checkbox>
                </v-flex>
                <v-flex xs6 class="px-2">
                  <v-checkbox hide-details
                  label="Is Monthly Rental"
                  :disabled="lProjContractServiceDet.action === 'view'"
                  v-model="lProjContractServiceDet.is_monthly_rental"></v-checkbox>
                </v-flex>
                <v-flex xs6 class="px-2">
                  <v-text-field
                  v-model="lProjContractServiceDet.months"
                  label="No. of Months"
                  type="number"
                  hide-details
                  :disabled="!lProjContractServiceDet.is_monthly_rental || lProjContractServiceDet.action === 'view'"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 class="px-2">
                  <v-dialog ref="dlgSPeriodFrom"
                  persistent v-model="dlgSPeriodFrom"
                  max-width="290px"
                  :return-value.sync="lProjContractServiceDet.contract_start_date"
                  >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                    slot="activator" label="Contract Start Date"
                    :rules="[rules.required]"
                    :disabled="lProjContractServiceDet.action === 'view'"
                    v-model="lProjContractServiceDet.contract_start_date" append-icon="mdi-calendar-today"
                    readonly clearable hide-details
                    v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="lProjContractServiceDet.contract_start_date" scrollable
                  first-day-of-week="1" :disabled="lProjContractServiceDet.action === 'view'"
                  >
                  <v-spacer></v-spacer>
                  <v-btn text @click="dlgSPeriodFrom = false">Cancel</v-btn>
                  <v-btn text color="accent" @click="$refs.dlgSPeriodFrom.save(lProjContractServiceDet.contract_start_date)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-flex>
            <v-flex xs6 class="px-2">
              <v-dialog ref="dlgSPeriodTo"
              persistent v-model="dlgSPeriodTo"
              max-width="290px"
              :return-value.sync="lProjContractServiceDet.contract_end_date"
              >
              <template v-slot:activator="{ on }">
                <v-text-field
                slot="activator" label="Contract End Date"
                :rules="[rules.required]"
                v-model="lProjContractServiceDet.contract_end_date" append-icon="mdi-calendar-today"
                readonly clearable hide-details
                v-on="on" :disabled="lProjContractServiceDet.action === 'view'"
                ></v-text-field>
              </template>
              <v-date-picker v-model="lProjContractServiceDet.contract_end_date" scrollable
              first-day-of-week="1" :disabled="lProjContractServiceDet.action === 'view'"
              >
              <v-spacer></v-spacer>
              <v-btn text @click="dlgSPeriodTo = false">Cancel</v-btn>
              <v-btn text color="accent" @click="$refs.dlgSPeriodTo.save(lProjContractServiceDet.contract_end_date)">OK</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-flex>
        <v-flex xs6 class="px-2">
          <v-text-field
          v-model="lProjContractServiceDet.Mgmt_fee_per"
          label="Mgmt %"
          type="number"
          hide-details
          :disabled="lProjContractServiceDet.action === 'view'"
          @input="calculateTotalmgmtAmt()"
          ></v-text-field>
        </v-flex>
        <v-flex xs6 class="px-2">
          <v-text-field
          v-model="lProjContractServiceDet.Mgmt_fee_amt"
          label="Mgmt Fee"
          type="number"
          disabled
          hide-details
          ></v-text-field>
        </v-flex>
        <v-flex xs6 class="px-2">
          <v-radio-group :disabled="lProjContractServiceDet.action === 'view'" v-model="lProjContractServiceDet.is_igst" :mandatory="true" row class="pt-0" hide-details>
            <v-radio label="CGST/SGST" value="0"></v-radio>
            <v-radio label="IGST" value="1"></v-radio>
          </v-radio-group>
        </v-flex>
        <v-flex xs6 class="px-2">
          <v-layout row wrap>
            <v-flex xs6 class="px-2">
              <v-text-field
              v-model="lProjContractServiceDet.igst_per"
              label="IGST %"
              type="number"
              hide-details
              :disabled="lProjContractServiceDet.is_igst === '1' && lProjContractServiceDet.action !== 'view' ? false : true"
              @input="calculateTotalmgmtAmt()"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 class="px-2">
              <v-text-field
              v-model="lProjContractServiceDet.igst_amt"
              label="IGST Fee"
              type="number"
              hide-details
              disabled
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 class="px-2">
          <v-layout row wrap>
            <v-flex xs3 class="px-2">
              <v-text-field
              v-model="lProjContractServiceDet.cgst_per"
              label="CGST %"
              type="number"
              hide-details
              :disabled="lProjContractServiceDet.is_igst === '1' || lProjContractServiceDet.action === 'view' ? true : false"
              @input="calculateTotalmgmtAmt()"
              ></v-text-field>
            </v-flex>
            <v-flex xs3 class="px-2">
              <v-text-field
              v-model="lProjContractServiceDet.cgst_amt"
              label="CGST Fee"
              type="number"
              hide-details
              disabled
              ></v-text-field>
            </v-flex>
            <v-flex xs3 class="px-2">
              <v-text-field
              v-model="lProjContractServiceDet.sgst_per"
              label="SGST %"
              type="number"
              hide-details
              :disabled="lProjContractServiceDet.is_igst === '1' || lProjContractServiceDet.action === 'view' ? true : false"
              @input="calculateTotalmgmtAmt()"
              ></v-text-field>
            </v-flex>
            <v-flex xs3 class="px-2">
              <v-text-field
              v-model="lProjContractServiceDet.sgst_amt"
              label="SGST Fee"
              type="number"
              hide-details
              disabled
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 class="px-2">
          <v-text-field
          v-model="lProjContractServiceDet.total_amt"
          label="Total"
          type="number"
          disabled
          hide-details
          ></v-text-field>
        </v-flex>
        <v-flex xs12 class="px-2">
          <v-textarea
          v-model="lProjContractServiceDet.comments"
          label="If any Comments"
          hide-details
          rows="2"
          maxlength="500"
          :disabled="lProjContractServiceDet.action !== 'view'"
          ></v-textarea>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-card-text>
  <v-card-actions class="px-0 pb-4">
    <v-spacer></v-spacer>
    <v-btn @click="showDet = false">cancel</v-btn>
    <v-btn :disabled="lProjContractServiceDet.action === 'view'" type="submit" class="accent">save</v-btn>
  </v-card-actions>
</v-card>
</v-form>
</v-flex>
</v-layout>
</v-flex>
</v-card-text>
</v-card>
</v-flex>
</v-dialog>

<!-- 3. give the comments based on version status -->
<v-dialog v-model="showCommentDlg" scrollable persistent max-width="500px">
  <v-card>
    <v-card-title class="px-3 py-2 title grey lighten-4">
      {{lProjContractStatus.status}} Remarks
      <v-spacer></v-spacer>
      <v-btn icon @click="showCommentDlg = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pa-3">
      <v-flex xs12 v-if="lProjContractStatus.status === 'Submitted'">
        <v-textarea hide-details outlined
        placeholder="Please Enter the Submit Remarks"
        maxlength="250"
        v-model="lProjContractStatus.submit_remarks"></v-textarea>
      </v-flex>
      <v-flex xs12 v-if="lProjContractStatus.status === 'Approved'">
        <v-textarea hide-details outlined
        placeholder="Please Enter the Approve Remarks"
        maxlength="250"
        v-model="lProjContractStatus.approve_remarks"></v-textarea>
      </v-flex>
      <v-flex xs12 v-if="lProjContractStatus.status === 'Draft'">
        <v-textarea hide-details outlined
        placeholder="Please Enter the Draft Remarks"
        maxlength="250"
        v-model="lProjContractStatus.drafted_remarks"></v-textarea>
      </v-flex>
      <v-flex xs12 v-if="lProjContractStatus.status === 'Rejected'">
        <v-textarea hide-details outlined
        placeholder="Please Enter the Rejected Remarks"
        maxlength="250"
        v-model="lProjContractStatus.rejected_remarks"></v-textarea>
      </v-flex>
    </v-card-text>
    <v-card-actions class="px-3 pt-0">
      <v-spacer></v-spacer>
      <v-btn class="accent" @click="statusChangeTheProjectContract(lProjContractStatus, lProjContractStatus.status)">save</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<!-- 4. show sub-cat based on selected cat -->
<v-dialog v-model="showSubCat" max-width="400px">
  <v-card>
    <v-card-title class="pa-3 title grey lighten-4">
      Sub-Category
      <v-spacer></v-spacer>
      <v-btn icon small @click="showSubCat = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-flex xs12 class="text-right pa-2">
        <v-btn small color="accent" @click="prepareSubCatItems(lProjContractDet.proj_contract_category_pair.proj_contract_category_id)">add new</v-btn>
      </v-flex>
      <v-flex xs12>
        <v-data-table
        :headers="subCatHeaders"
        :items="subcatList"
        disable-sort
        hide-default-footer
        disable-pagination
        :mobile-breakpoint="0">
        <template slot="item" slot-scope="props">
          <tr @click="prepareUpdateSubCat(props.item)">
            <td style="font-size: 12px;">{{ props.item.proj_contract_sub_category }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
  </v-card-text>
</v-card>
</v-dialog>

<!-- 5. Add/update/delete sub-cat -->
<v-dialog v-model="showSubCatForm" max-width="500px">
  <v-flex xs12>
    <v-form ref="cForm" @submit.prevent="saveSubCat(lSubCat.action)">
      <v-card>
        <v-card-title primary-title>
          {{lSubCat.action ? handy.startWithUpper(lSubCat.action) : ''}} Sub-Category
          <v-spacer></v-spacer>
          <v-btn icon small @click="showSubCatForm = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-flex xs12>
            <v-text-field
            v-model="lSubCat.proj_contract_sub_category"
            label="Sub-category"
            hide-details
            maxlength="100"
            ></v-text-field>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="saveSubCat('delete')">delete</v-btn>
          <v-btn class="accent" type="submit">save</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-flex>
</v-dialog>

<!-- 6. project contract view based on base id -->
<v-dialog scrollable v-model="showViewAsPdf" max-width="900px">
  <v-card>
    <v-card-title class="py-2 grey lighten-3">
      Project Contract
      <v-spacer></v-spacer>
      <v-btn icon small @click="showViewAsPdf = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12 class="py-1">
        <v-layout row wrap>
          <v-flex xs8>
            <v-alert dense border="top" text class="pa-2 mb-0 black--text" color="primary lighten-2">
              <div style="font-size: 11px;">
                If you are facing issue while downloading PDF. Please clear your browser cache and download it again.
              </div>
            </v-alert>
          </v-flex>
          <v-flex xs4 class="text-right">
            <v-btn small class="primary lighten-1" @click="downloadAsPdf">Download As Pdf</v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 id="pdf_report">
        <v-card flat>
          <v-card-text class="pa-0">
            <v-flex xs12>
              <v-layout row wrap style="margin-bottom: 4px; padding-bottom: 4px;">
                <v-flex xs8>
                  <div style="font-family: Arial, Helvetica, sans-serif; color:#000; padding-top: 2px; font-size: 22px;">{{lProjContractBase.proj_name}} - (Commercials)</div>
                </v-flex>
                <v-flex xs4 style="text-align: right; font-family: Arial, Helvetica, sans-serif;">
                  <span style="color: #000;">Status: </span><span :style="lStatus === 'Submitted' ? 'font-weight:bold; color: #FFA500;' : lStatus === 'Approved' ? 'font-weight:bold; color: #008000;' : 'font-weight:bold; color: #FF0000;'">{{lStatus}}</span>
                  <span style="font-weight:bold; font-family: Arial, Helvetica, sans-serif; color: #4570d6; padding-right: 5px;"> ({{'Version ' + lVersion + '.0'}})</span>
                </v-flex>
              </v-layout>
            </v-flex>
            <!-- 1st and 2nd view-->
            <v-flex xs12 style="padding-right: 5px;" v-if="attTab === 'tab-0' || attTab === 'tab-1'">
              <v-layout row wrap>
                <v-flex xs12 v-if="projContractView[0] && projContractView[0].length > 0 && projContractView[0][0].proj_contract_sub_category">
                  <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
                    <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;font-weight: semi-bold;">{{projContractView[0][0].heading}}</div>
                    <v-data-table
                    :headers="techHeaders"
                    hide-default-header
                    :items="projContractView[0]"
                    disable-sort
                    hide-default-footer
                    dense
                    disable-pagination>
                    <template v-slot:header="{ props: { headers } }">
                      <thead>
                        <tr>
                          <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 368px; text-align: left;">{{headers[0].text}}</th>
                          <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
                          <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[2].text}}</th>
                        </tr>
                      </thead>
                    </template>
                    <template slot="item" slot-scope="props">
                      <tr>
                        <td style="font-size: 12px; color:#000; border-bottom: 1px solid #bebebe; vertical-align: top; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.proj_contract_sub_category }}</td>
                        <td style="font-size: 12px; color:#000; border-bottom: 1px solid #bebebe; vertical-align: top; text-align: right; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amount }}</td>
                        <td style="font-size: 12px; color:#000; border-bottom: 1px solid #bebebe; vertical-align: top; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                  <v-flex xs12>
                    <table width="100%" cellpadding="0" cellspacing="0">
                      <tbody>
                        <tr style="background-color: #fff; font-family: Arial, Helvetica, sans-serif; color: #000;">
                          <td style="font-size: 12px; padding: 4px 16px; width: 368px;">Sub Total</td>
                          <td style="font-size: 12px; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                            {{ handy.formatCur(projContractView[0].total_amount) }}
                          </td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </v-flex>
                  <v-flex xs12 v-if="attTab === 'tab-0'">
                    <table width="100%" cellpadding="0" cellspacing="0">
                      <tbody>
                        <tr style="font-family: Arial, Helvetica, sans-serif; color: #000;" v-for="(mgmt, i) in projContractView[1]" :key="i">
                          <td style="font-size: 12px; padding: 4px 16px; width: 368px;">Management fees ({{mgmt.tot_amt}} {{handy.formatCur(mgmt.amount)}} on FMS)</td>
                          <td style="font-size: 12px; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                            {{ handy.formatCur(mgmt.Mgmt_fee_amt) }}
                          </td>
                          <td></td>
                        </tr>
                        <tr style="background-color: #93f0cf; font-family: Arial, Helvetica, sans-serif; color: #09391f;">
                          <td style="font-size: 12px; font-weight: bold; padding: 4px 16px; width: 368px;">Total Before Tax</td>
                          <td style="font-size: 12px; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                            {{ handy.formatCur(projContractView[0].before_gst) }}
                          </td>
                          <td></td>
                        </tr>
                        <tr style="font-family: Arial, Helvetica, sans-serif; color: #000;" v-for="gst in projContractView[2]" :key="gst.gst_amt">
                          <td style="font-size: 12px; padding: 4px 16px; width: 368px;">GST {{gst.tax_per}} % of {{handy.formatCur(gst.gst_amt)}}</td>
                          <td style="font-size: 12px; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                            {{ handy.formatCur(gst.tax_amt) }}
                          </td>
                          <td></td>
                        </tr>
                        <tr style="background-color: #44cb82; font-family: Arial, Helvetica, sans-serif; color: #fff;">
                          <td style="font-size: 12px; font-weight: bold; padding: 4px 16px; width: 368px;">{{projContractView[0][0].heading.substring(10, projContractView[0][0].heading.length)}} Grand Total with GST</td>
                          <td style="font-size: 12px; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                            {{ handy.formatCur(projContractView[0].gst_tax_amt) }}
                          </td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </v-flex>
                </v-flex>
              </v-flex>
              <div style="page-break-after:always; clear:both"></div>
              <v-flex xs12 style="padding-top: 8px;" v-if="projContractView[3] && projContractView[3].length > 0 && projContractView[3][0].staff_role">
                <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
                  <div style="background-color: #4570d6; padding: 4px 0px; color: #fff; text-align: center; font-family: Arial, Helvetica, sans-serif;">{{projContractView[3][0].heading}}</div>
                  <v-flex xs12>
                    <v-flex xs12 v-for="(cat, i) in category" :key="i" v-if="projContractView[3].filter(rec => rec.role_cat === cat).length > 0">
                      <div style="padding: 4px 0px; font-size: 12px; font-family: Arial, Helvetica, sans-serif; background-color: #71c1f5; color: #000; text-align: center;">
                        {{handy.startWithUpper(cat.toLowerCase())}}
                      </div>
                      <v-data-table
                      :headers="manpowerHeaders"
                      hide-default-header
                      :items="projContractView[3].filter(rec => rec.role_cat === cat)"
                      hide-default-footer
                      disable-sort
                      dense
                      disable-pagination
                      >
                      <template v-slot:header="{ props: { headers } }">
                        <thead>
                          <tr>
                            <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 150px; text-align: left;">{{headers[0].text}}</th>
                            <th style="background-color: #cee6f5;font-size: 12px; padding: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
                            <th style="background-color: #cee6f5;font-size: 12px; padding: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[2].text}}</th>
                            <th style="background-color: #cee6f5;font-size: 12px; padding-right: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[3].text}}</th>
                            <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[4].text}}</th>
                          </tr>
                        </thead>
                      </template>
                      <template slot="item" slot-scope="props">
                        <tr>
                          <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.staff_role }}</td>
                          <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.head_count }}</td>
                          <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amt_per_hc }}</td>
                          <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.total_hc_amt }}</td>
                          <td style="font-size: 12px; border-bottom: 1px solid #bebebe; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-flex>
                  <v-flex xs12>
                    <table width="100%" cellpadding="0" cellspacing="0">
                      <tbody>
                        <tr style="color: #000;">
                          <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">Sub Total</td>
                          <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
                            {{ handy.formatCur(projContractView[3].total_amount) }}
                          </td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </v-flex>
                  <v-flex xs12 v-if="attTab === 'tab-0'">
                    <table width="100%" cellpadding="0" cellspacing="0">
                      <tbody>
                        <tr style="color: #000;" v-for="mgmt in projContractView[4]" :key="mgmt.Mgmt_fee_per">
                          <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">Management fees ({{mgmt.Mgmt_fee_per}} {{handy.formatCur(mgmt.amount)}} on FMS)</td>
                          <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
                            {{ handy.formatCur(mgmt.Mgmt_fee_amt) }}
                          </td>
                          <td></td>
                        </tr>
                        <tr style="background-color: #93f0cf; color:#09391f;">
                          <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">Total Before Tax</td>
                          <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
                            {{ handy.formatCur(projContractView[3].before_gst) }}
                          </td>
                          <td></td>
                        </tr>
                        <tr style="color: #000;" v-for="gst in projContractView[5]" :key="gst.gst_amt">
                          <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">GST {{gst.tax_per}} % of {{handy.formatCur(gst.gst_amt)}}</td>
                          <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
                            {{ handy.formatCur(gst.tax_amt) }}
                          </td>
                          <td></td>
                        </tr>
                        <tr style="background-color: #44cb82; color: #fff;">
                          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">{{projContractView[3][0].heading.substring(8, projContractView[3][0].heading.length)}} Grand Total with GST</td>
                          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                            {{ handy.formatCur(projContractView[3].gst_tax_amt) }}
                          </td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </v-flex>
                </v-flex>
              </v-flex>
            </v-flex>
            <div style="page-break-after:always; clear:both"></div>
            <v-flex xs12 style="padding-top: 8px;" v-if="projContractView[6] && projContractView[6].length && projContractView[6][0].staff_role">
              <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
                <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;">{{projContractView[6][0].heading}}</div>
                <v-flex xs12 v-if="projContractView[6].filter(rec => rec.role_cat === 'SAFTY/SECURITY').length > 0">
                  <v-divider class="black"></v-divider>
                  <v-data-table
                  :headers="manpowerHeaders"
                  hide-default-header
                  :items="projContractView[6]"
                  disable-sort
                  hide-default-footer
                  dense
                  disable-pagination
                  >
                  <template v-slot:header="{ props: { headers } }">
                    <thead>
                      <tr>
                        <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 150px; text-align: left;">{{headers[0].text}}</th>
                        <th style="background-color: #cee6f5;font-size: 12px; padding: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
                        <th style="background-color: #cee6f5;font-size: 12px; padding: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[2].text}}</th>
                        <th style="background-color: #cee6f5;font-size: 12px; padding-right: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[3].text}}</th>
                        <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[4].text}}</th>
                      </tr>
                    </thead>
                  </template>
                  <template slot="item" slot-scope="props">
                    <tr>
                      <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.staff_role }}</td>
                      <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.head_count }}</td>
                      <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amt_per_hc }}</td>
                      <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.total_hc_amt }}</td>
                      <td style="font-size: 12px; border-bottom: 1px solid #bebebe; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
                    </tr>
                  </template>
                </v-data-table>
                <v-flex xs12>
                  <table width="100%" cellpadding="0" cellspacing="0">
                    <tbody>
                      <tr style="color: #000;">
                        <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Sub Total</td>
                        <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                          {{ handy.formatCur(projContractView[6].total_amount) }}
                        </td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </v-flex>
                <v-flex xs12 v-if="attTab === 'tab-0'">
                  <table width="100%" cellpadding="0" cellspacing="0">
                    <tbody>
                      <tr style="color: #000;" v-for="mgmt in projContractView[7]" :key="mgmt.Mgmt_fee_per">
                        <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px; width: 100px;">Management fees ({{mgmt.Mgmt_fee_per}} % of {{handy.formatCur(mgmt.amount)}} on FMS)</td>
                        <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                          {{ handy.formatCur(mgmt.Mgmt_fee_amt) }}
                        </td>
                        <td></td>
                      </tr>
                      <tr style="background-color: #93f0cf; color:#09391f;">
                        <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Total Before Tax</td>
                        <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                          {{ handy.formatCur(projContractView[6].before_gst) }}
                        </td>
                        <td></td>
                      </tr>
                      <tr style="color: #000;" v-for="gst in projContractView[8]" :key="gst.gst_amt">
                        <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">GST {{gst.tax_per}} % of {{handy.formatCur(gst.gst_amt)}}</td>
                        <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                          {{ handy.formatCur(gst.tax_amt) }}
                        </td>
                        <td></td>
                      </tr>
                      <tr style="background-color: #44cb82; color: #fff;">
                        <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">{{projContractView[6][0].heading.substring(8, projContractView[6][0].heading.length)}} Grand Total with GST</td>
                        <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                          {{ handy.formatCur(projContractView[6].gst_tax_amt) }}
                        </td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </v-flex>
              </v-flex>
            </v-flex>
          </v-flex>
          <div style="page-break-after:always; clear:both"></div>
          <v-flex xs12 style="padding-top: 8px;" v-if="projContractView[9] && projContractView[9].length && projContractView[9][0].proj_contract_sub_category">
            <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
              <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;">{{projContractView[9][0].heading}}</div>
              <v-data-table
              :headers="techHeaders"
              hide-default-header
              disable-sort
              :items="projContractView[9]"
              hide-default-footer
              dense
              disable-pagination
              >
              <template v-slot:header="{ props: { headers } }">
                <thead>
                  <tr>
                    <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 368px; text-align: left;">{{headers[0].text}}</th>
                    <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
                    <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[2].text}}</th>
                  </tr>
                </thead>
              </template>
              <template slot="item" slot-scope="props">
                <tr>
                  <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.proj_contract_sub_category }}</td>
                  <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amount }}</td>
                  <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
                </tr>
              </template>
            </v-data-table>
            <v-flex xs12>
              <table width="100%" cellpadding="0" cellspacing="0">
                <tbody>
                  <tr style="color: #000;">
                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Sub Total</td>
                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                      {{ handy.formatCur(projContractView[9].total_amount) }}
                    </td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </v-flex>
            <v-flex xs12 v-if="attTab === 'tab-0'">
              <table width="100%" cellpadding="0" cellspacing="0">
                <tbody>
                  <tr style="color: #000;" v-for="mgmt in projContractView[10]" :key="mgmt.Mgmt_fee_per">
                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Management fees ({{mgmt.tot_amt}} {{handy.formatCur(mgmt.amount)}} on FMS)</td>
                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                      {{ handy.formatCur(mgmt.Mgmt_fee_amt) }}
                    </td>
                    <td></td>
                  </tr>
                  <tr style="background-color: #93f0cf; color:#09391f;">
                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Total Before Tax</td>
                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                      {{ handy.formatCur(projContractView[9].before_gst) }}
                    </td>
                    <td></td>
                  </tr>
                  <tr style="color: #000;" v-for="gst in projContractView[11]" :key="gst.gst_amt">
                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">GST {{gst.tax_per}} % of {{handy.formatCur(gst.gst_amt)}}</td>
                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                      {{ handy.formatCur(gst.tax_amt) }}
                    </td>
                    <td></td>
                  </tr>
                  <tr style="background-color: #44cb82; color: #fff;">
                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">{{projContractView[9][0].heading.substring(21, projContractView[9][0].heading.length)}} Grand Total with GST</td>
                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                      {{ handy.formatCur(projContractView[9].gst_tax_amt) }}
                    </td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </v-flex>
          </v-flex>
        </v-flex>
        <div style="page-break-after:always; clear:both"></div>
        <v-flex xs12 style="padding-top: 8px;" v-if="projContractView[12] && projContractView[12].length && projContractView[12][0].proj_contract_sub_category">
          <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
            <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;">{{projContractView[12][0].heading}}</div>
            <v-data-table
            :headers="techHeaders"
            hide-default-header
            disable-sort
            :items="projContractView[12]"
            hide-default-footer
            dense
            disable-pagination
            >
            <template v-slot:header="{ props: { headers } }">
              <thead>
                <tr>
                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 368px; text-align: left;">{{headers[0].text}}</th>
                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[2].text}}</th>
                </tr>
              </thead>
            </template>
            <template slot="item" slot-scope="props">
              <tr>
                <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.proj_contract_sub_category }}</td>
                <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amount }}</td>
                <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
              </tr>
            </template>
          </v-data-table>
          <v-flex xs12>
            <table width="100%" cellpadding="0" cellspacing="0">
              <tbody>
                <tr style="color: #000;">
                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Sub Total</td>
                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                    {{ handy.formatCur(projContractView[12].total_amount) }}
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </v-flex>
          <v-flex xs12 v-if="attTab === 'tab-0'">
            <table width="100%" cellpadding="0" cellspacing="0">
              <tbody>
                <tr style="color: #000;" v-for="mgmt in projContractView[13]" :key="mgmt.Mgmt_fee_per">
                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Management fees ({{mgmt.tot_amt}} % of {{handy.formatCur(mgmt.amount)}} on FMS)</td>
                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                    {{ handy.formatCur(mgmt.Mgmt_fee_amt) }}
                  </td>
                  <td></td>
                </tr>
                <tr style="background-color: #93f0cf; color:#09391f;">
                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Total Before Tax</td>
                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                    {{ handy.formatCur(projContractView[12].before_gst) }}
                  </td>
                  <td></td>
                </tr>
                <tr style="color: #000;" v-for="gst in projContractView[14]" :key="gst.gst_amt">
                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">GST {{gst.tax_per}} % of {{handy.formatCur(gst.gst_amt)}}</td>
                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                    {{ handy.formatCur(gst.tax_amt) }}
                  </td>
                  <td></td>
                </tr>
                <tr style="background-color: #44cb82; color: #fff;">
                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">{{projContractView[12][0].heading.substring(13, projContractView[12][0].heading.length)}} Grand Total with GST</td>
                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                    {{ handy.formatCur(projContractView[12].gst_tax_amt) }}
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </v-flex>
        </v-flex>
      </v-flex>
      <div style="page-break-after:always; clear:both"></div>
      <v-flex xs12 style="padding-top: 8px;" v-if="projContractView[15] && projContractView[15].length && projContractView[15][0].proj_contract_sub_category">
        <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
          <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;">{{projContractView[15][0].heading}}</div>
          <v-data-table
          :headers="techHeaders"
          hide-default-header
          disable-sort
          :items="projContractView[15]"
          hide-default-footer
          dense
          disable-pagination
          >
          <template v-slot:header="{ props: { headers } }">
            <thead>
              <tr>
                <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 368px; text-align: left;">{{headers[0].text}}</th>
                <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
                <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[2].text}}</th>
              </tr>
            </thead>
          </template>
          <template slot="item" slot-scope="props">
            <tr>
              <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.proj_contract_sub_category }}</td>
              <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amount }}</td>
              <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
            </tr>
          </template>
        </v-data-table>
        <v-flex xs12>
          <table width="100%" cellpadding="0" cellspacing="0">
            <tbody>
              <tr style="color: #000;">
                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Sub Total</td>
                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                  {{ handy.formatCur(projContractView[15].total_amount) }}
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </v-flex>
        <v-flex xs12 v-if="attTab === 'tab-0'">
          <table width="100%" cellpadding="0" cellspacing="0">
            <tbody>
              <tr style="color: #000;" v-for="mgmt in projContractView[16]" :key="mgmt.Mgmt_fee_per">
                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Management fees ({{mgmt.tot_amt}} {{handy.formatCur(mgmt.amount)}} on FMS)</td>
                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                  {{ handy.formatCur(mgmt.Mgmt_fee_amt) }}
                </td>
                <td></td>
              </tr>
              <tr style="background-color: #93f0cf; color:#09391f;">
                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Total Before Tax</td>
                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                  {{ handy.formatCur(projContractView[15].before_gst) }}
                </td>
                <td></td>
              </tr>
              <tr style="color: #000;" v-for="gst in projContractView[17]" :key="gst.gst_amt">
                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">GST {{gst.tax_per}} % of {{handy.formatCur(gst.gst_amt)}}</td>
                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                  {{ handy.formatCur(gst.tax_amt) }}
                </td>
                <td></td>
              </tr>
              <tr style="background-color: #44cb82; color: #fff;">
                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">{{projContractView[15][0].heading.substring(13, projContractView[15][0].heading.length)}} Grand Total with GST</td>
                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                  {{ handy.formatCur(projContractView[15].gst_tax_amt) }}
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </v-flex>
      </v-flex>
    </v-flex>
    <div style="page-break-after:always; clear:both"></div>
    <v-flex xs12 style="padding-top: 8px;" v-if="projContractView[18] && projContractView[18].length && projContractView[18][0].proj_contract_sub_category">
      <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
        <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;">{{projContractView[18][0].heading}}</div>
        <v-data-table
        :headers="techHeaders"
        hide-default-header
        disable-sort
        :items="projContractView[18]"
        hide-default-footer
        dense
        disable-pagination
        >
        <template v-slot:header="{ props: { headers } }">
          <thead>
            <tr>
              <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 368px; text-align: left;">{{headers[0].text}}</th>
              <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
              <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[2].text}}</th>
            </tr>
          </thead>
        </template>
        <template slot="item" slot-scope="props">
          <tr>
            <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.proj_contract_sub_category }}</td>
            <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amount }}</td>
            <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
          </tr>
        </template>
      </v-data-table>
      <v-flex xs12>
        <table width="100%" cellpadding="0" cellspacing="0">
          <tbody>
            <tr style="color: #000;">
              <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Sub Total</td>
              <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                {{ handy.formatCur(projContractView[18].total_amount) }}
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </v-flex>
      <v-flex xs12 v-if="attTab === 'tab-0'">
        <table width="100%" cellpadding="0" cellspacing="0">
          <tbody>
            <tr style="color: #000;" v-for="mgmt in projContractView[19]" :key="mgmt.Mgmt_fee_per">
              <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Management fees ({{mgmt.tot_amt}} {{handy.formatCur(mgmt.amount)}} on FMS)</td>
              <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                {{ handy.formatCur(mgmt.Mgmt_fee_amt) }}
              </td>
              <td></td>
            </tr>
            <tr style="background-color: #93f0cf; color:#09391f;">
              <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Total Before Tax</td>
              <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                {{ handy.formatCur(projContractView[18].before_gst) }}
              </td>
              <td></td>
            </tr>
            <tr style="color: #000;" v-for="gst in projContractView[20]" :key="gst.gst_amt">
              <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">GST {{gst.tax_per}} % of {{handy.formatCur(gst.gst_amt)}}</td>
              <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                {{ handy.formatCur(gst.tax_amt) }}
              </td>
              <td></td>
            </tr>
            <tr style="background-color: #44cb82; color: #fff;">
              <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">{{projContractView[18][0].heading.substring(5, projContractView[18][0].heading.length)}} Grand Total with GST</td>
              <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                {{ handy.formatCur(projContractView[18].gst_tax_amt) }}
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </v-flex>
    </v-flex>
  </v-flex>
  <div style="page-break-after:always; clear:both"></div>
  <v-flex xs12 style="padding-top: 8px;" v-if="projContractView[21] && projContractView[21].length && projContractView[21][0].proj_contract_sub_category">
    <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
      <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;">{{projContractView[21][0].heading}}</div>
      <v-data-table
      :headers="techHeaders"
      hide-default-header
      disable-sort
      :items="projContractView[21]"
      hide-default-footer
      dense
      disable-pagination
      >
      <template v-slot:header="{ props: { headers } }">
        <thead>
          <tr>
            <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 368px; text-align: left;">{{headers[0].text}}</th>
            <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
            <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[2].text}}</th>
          </tr>
        </thead>
      </template>
      <template slot="item" slot-scope="props">
        <tr>
          <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.proj_contract_sub_category }}</td>
          <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amount }}</td>
          <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
        </tr>
      </template>
    </v-data-table>
    <v-flex xs12>
      <table width="100%" cellpadding="0" cellspacing="0">
        <tbody>
          <tr style="color: #000;">
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Sub Total</td>
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
              {{ handy.formatCur(projContractView[21].total_amount) }}
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </v-flex>
    <v-flex xs12 v-if="attTab === 'tab-0'">
      <table width="100%" cellpadding="0" cellspacing="0">
        <tbody>
          <tr style="color: #000;" v-for="mgmt in projContractView[22]" :key="mgmt.Mgmt_fee_per">
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Management fees ({{mgmt.tot_amt}} {{handy.formatCur(mgmt.amount)}} on FMS)</td>
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
              {{ handy.formatCur(mgmt.Mgmt_fee_amt) }}
            </td>
            <td></td>
          </tr>
          <tr style="background-color: #93f0cf; color:#09391f;">
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Total Before Tax</td>
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
              {{ handy.formatCur(projContractView[21].before_gst) }}
            </td>
            <td></td>
          </tr>
          <tr style="color: #000;" v-for="gst in projContractView[23]" :key="gst.gst_amt">
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">GST {{gst.tax_per}} % of {{handy.formatCur(gst.gst_amt)}}</td>
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
              {{ handy.formatCur(gst.tax_amt) }}
            </td>
            <td></td>
          </tr>
          <tr style="background-color: #44cb82; color: #fff;">
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">{{projContractView[21][0].heading.substring(20, projContractView[21][0].heading.length)}} Grand Total with GST</td>
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
              {{ handy.formatCur(projContractView[21].gst_tax_amt) }}
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </v-flex>
  </v-flex>
</v-flex>
<div style="page-break-after:always; clear:both"></div>
<v-flex xs12 style="padding-top: 8px;" v-if="projContractView[24] && projContractView[24].length && projContractView[24][0].proj_contract_sub_category">
  <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
    <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;">{{projContractView[24][0].heading}}</div>
    <v-data-table
    :headers="techHeaders"
    hide-default-header
    disable-sort
    :items="projContractView[24]"
    hide-default-footer
    dense
    disable-pagination
    >
    <template v-slot:header="{ props: { headers } }">
      <thead>
        <tr>
          <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 368px; text-align: left;">{{headers[0].text}}</th>
          <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
          <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[2].text}}</th>
        </tr>
      </thead>
    </template>
    <template slot="item" slot-scope="props">
      <tr>
        <td style="font-size: 12px; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.proj_contract_sub_category }}</td>
        <td style="font-size: 12px; text-align: right; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amount }}</td>
        <td style="font-size: 12px; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
      </tr>
    </template>
  </v-data-table>
  <v-flex xs12>
    <table width="100%" cellpadding="0" cellspacing="0">
      <tbody>
        <tr style="color: #000;">
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Sub Total</td>
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
            {{ handy.formatCur(projContractView[24].total_amount) }}
          </td>
          <td></td>
        </tr>
      </tbody>
    </table>
  </v-flex>
  <v-flex xs12 v-if="attTab === 'tab-0'">
    <table width="100%" cellpadding="0" cellspacing="0">
      <tbody>
        <tr style="color: #000;" v-for="mgmt in projContractView[25]" :key="mgmt.Mgmt_fee_per">
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Management fees ({{mgmt.tot_amt}} {{handy.formatCur(mgmt.amount)}} on FMS)</td>
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
            {{ handy.formatCur(mgmt.Mgmt_fee_amt) }}
          </td>
          <td></td>
        </tr>
        <tr style="background-color: #93f0cf; color:#09391f;">
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Total Before Tax</td>
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
            {{ handy.formatCur(projContractView[24].before_gst) }}
          </td>
          <td></td>
        </tr>
        <tr style="color: #000;" v-for="gst in projContractView[26]" :key="gst.gst_amt">
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">GST {{gst.tax_per}} % of {{handy.formatCur(gst.gst_amt)}}</td>
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
            {{ handy.formatCur(gst.tax_amt) }}
          </td>
          <td></td>
        </tr>
        <tr style="background-color: #44cb82; color: #fff;">
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">{{projContractView[24][0].heading.substring(9, projContractView[24][0].heading.length)}} Grand Total with GST</td>
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
            {{ handy.formatCur(projContractView[24].gst_tax_amt) }}
          </td>
          <td></td>
        </tr>
        <tr style="background-color: #44cb82; color: #fff;">
          <td colspan="3"></td>
        </tr>
      </tbody>
    </table>
  </v-flex>
</v-flex>
</v-flex>
<!-- SUMMARY -->
<div style="page-break-after:always; clear:both"></div>
<v-flex xs12 style="padding-top: 8px; padding-bottom: 12px;" v-if="projContractView[27] && projContractView[27][0].sub_total">
  <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
    <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;">SUMMARY</div>
    <table width="100%" cellpadding="0" cellspacing="0">
      <tbody>
        <tr style="color: #000;">
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Grand Total</td>
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
            {{ handy.formatCur(projContractView[27][0].sub_total) }}
          </td>
          <td></td>
        </tr>
        <tr style="color: #000;">
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Management Fee</td>
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
            {{ handy.formatCur(projContractView[27][0].mgmt_fee) }}
          </td>
          <td></td>
        </tr>
        <tr style="background-color: #93f0cf; color:#09391f;">
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Total Before Tax</td>
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
            {{ handy.formatCur(projContractView[27][0].before_gst) }}
          </td>
          <td></td>
        </tr>
        <tr style="color: #000;">
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">GST</td>
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
            {{ handy.formatCur(projContractView[27][0].tax_amt) }}
          </td>
          <td></td>
        </tr>
        <tr style="background-color: #44cb82; color: #fff;">
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Grand Total After GST</td>
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
            {{ handy.formatCur(projContractView[27][0].after_gst) }}
          </td>
          <td></td>
        </tr>
      </tbody>
    </table>
  </v-flex>
</v-flex>
<v-flex xs12 v-else>
  <div>
    No Data Available
  </div>
</v-flex>
</v-layout>
</v-flex>

<!-- 3rd view -->
<v-flex xs12 style="padding-right: 5px;" v-if="attTab === 'tab-2'">
  <v-layout row wrap>
    <v-flex xs12 style="border: 1px solid black; border-radius: 0px;" v-if="projContractView[27] && projContractView[27][0].sub_total">
      <v-data-table
      :headers="manpowerHeaders"
      hide-default-header
      disable-sort
      :items="projContractView[0].concat(projContractView[3]).concat(projContractView[6]).concat(projContractView[9]).concat(projContractView[12]).concat(projContractView[15]).concat(projContractView[18]).concat(projContractView[21]).concat(projContractView[24])"
      hide-default-footer
      dense
      disable-pagination>
      <template v-slot:header="{ props: { headers } }">
        <thead>
          <tr>
            <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 150px; text-align: left;">{{headers[0].text}}</th>
            <th style="background-color: #cee6f5;font-size: 12px; padding: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
            <th style="background-color: #cee6f5;font-size: 12px; padding: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[2].text}}</th>
            <th style="background-color: #cee6f5;font-size: 12px; padding-right: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[3].text}}</th>
            <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[4].text}}</th>
          </tr>
        </thead>
      </template>
      <template slot="item" slot-scope="props">
        <tr v-if="props.item.staff_role || props.item.proj_contract_sub_category">
          <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.staff_role ? props.item.staff_role : props.item.proj_contract_sub_category }}</td>
          <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.head_count ? props.item.head_count : 1 }}</td>
          <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amt_per_hc ? props.item.amt_per_hc : props.item.amount }}</td>
          <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.total_hc_amt ? props.item.total_hc_amt : props.item.amount }}</td>
          <td style="border-bottom: 1px solid #bebebe; font-size: 12px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-flex>
  <div style="page-break-after:always; clear:both"></div>
  <v-flex xs12 style="padding-top: 8px; padding-bottom: 12px;" v-if="projContractView[27] && projContractView[27][0].sub_total">
    <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
      <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;">SUMMARY</div>
      <table width="100%" cellpadding="0" cellspacing="0">
        <tbody>
          <tr style="color: #000;">
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Grand Total</td>
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
              {{ handy.formatCur(projContractView[27][0].sub_total) }}
            </td>
            <td></td>
          </tr>
          <tr style="color: #000;">
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Management Fee</td>
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
              {{ handy.formatCur(projContractView[27][0].mgmt_fee) }}
            </td>
            <td></td>
          </tr>
          <tr style="background-color: #93f0cf; color:#09391f;">
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px; color:#09391f;">Total Before Tax</td>
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
              {{ handy.formatCur(projContractView[27][0].before_gst) }}
            </td>
            <td></td>
          </tr>
          <tr style="color: #000;">
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">GST</td>
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
              {{ handy.formatCur(projContractView[27][0].tax_amt) }}
            </td>
            <td></td>
          </tr>
          <tr style="background-color: #44cb82; color: #fff;">
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Grand Total After GST</td>
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
              {{ handy.formatCur(projContractView[27][0].after_gst) }}
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </v-flex>
  </v-flex>
  <v-flex xs12 v-else>
    <div>
      No Data Available
    </div>
  </v-flex>
</v-layout>
</v-flex>

<!-- 4th view -->
<v-flex xs12 style="padding-right: 5px;" v-if="attTab === 'tab-3'">
  <v-layout row wrap>
    <v-flex xs12 v-if="(projContractView[3] && projContractView[3].length > 0  && projContractView[3][0].staff_role) || (projContractView[6] && projContractView[6].length > 0 && projContractView[6][0].staff_role)">
      <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
        <div style="background-color: #4570d6; padding: 4px 0px; color: #fff; text-align: center; font-family: Arial, Helvetica, sans-serif;">MANPOWER</div>
        <v-data-table
        :headers="manpowerHeaders"
        hide-default-header
        disable-sort
        :items="projContractView[3].concat(projContractView[6])"
        hide-default-footer
        dense
        disable-pagination>
        <template v-slot:header="{ props: { headers } }">
          <thead>
            <tr>
              <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 150px; text-align: left;">{{headers[0].text}}</th>
              <th style="background-color: #cee6f5;font-size: 12px; padding: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
              <th style="background-color: #cee6f5;font-size: 12px; padding: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[2].text}}</th>
              <th style="background-color: #cee6f5;font-size: 12px; padding-right: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[3].text}}</th>
              <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[4].text}}</th>
            </tr>
          </thead>
        </template>
        <template slot="item" slot-scope="props">
          <tr>
            <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.staff_role }}</td>
            <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.head_count }}</td>
            <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amt_per_hc }}</td>
            <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.total_hc_amt }}</td>
            <td style="border-bottom: 1px solid #bebebe; font-size: 12px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
          </tr>
        </template>
      </v-data-table>
      <v-flex xs12>
        <table width="100%" cellpadding="0" cellspacing="0">
          <tbody>
            <tr style="color: #000;">
              <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">Sub Total</td>
              <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
                {{ handy.formatCur((projContractView[3].total_amount ? projContractView[3].total_amount : 0) + (projContractView[6].total_amount ? projContractView[6].total_amount : 0)) }}
              </td>
              <td></td>
            </tr>
            <tr style="color: #000;">
              <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">Management fees</td>
              <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
                {{ handy.formatCur((projContractView[3].mgmt ? projContractView[3].mgmt : 0) + (projContractView[6].mgmt ? projContractView[6].mgmt : 0)) }}
              </td>
              <td></td>
            </tr>
            <tr style="background-color: #93f0cf; color:#09391f;">
              <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px; color:#09391f;">Total Before Tax</td>
              <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
                {{ handy.formatCur((projContractView[3].before_gst ? projContractView[3].before_gst : 0) + (projContractView[6].before_gst ? projContractView[6].before_gst : 0)) }}
              </td>
              <td></td>
            </tr>
            <tr style="color: #000;">
              <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">GST</td>
              <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
                {{ handy.formatCur((projContractView[3].tax_amt ? projContractView[3].tax_amt : 0) + (projContractView[6].tax_amt ? projContractView[6].tax_amt : 0)) }}
              </td>
              <td></td>
            </tr>
            <tr style="background-color: #44cb82; color: #fff;">
              <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Grand Total with GST</td>
              <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                {{ handy.formatCur((projContractView[3].gst_tax_amt ? projContractView[3].gst_tax_amt : 0) + (projContractView[6].gst_tax_amt ? projContractView[6].gst_tax_amt : 0)) }}
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </v-flex>
    </v-flex>
  </v-flex>
  <v-flex xs12 style="padding-top: 6px;" v-if="projContractView[28] && projContractView[28][0].total_amount">
    <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
      <div style="background-color: #4570d6; padding: 4px 0px; color: #fff; text-align: center; font-family: Arial, Helvetica, sans-serif;">SERVICE</div>
      <v-data-table
      :headers="techHeaders"
      hide-default-header
      disable-sort
      :items="projContractView[0].concat(projContractView[9]).concat(projContractView[12]).concat(projContractView[15]).concat(projContractView[18]).concat(projContractView[21]).concat(projContractView[24])"
      hide-default-footer
      dense
      disable-pagination>
      <template v-slot:header="{ props: { headers } }">
        <thead>
          <tr>
            <th style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 368px; text-align: left;">{{headers[0].text}}</th>
            <th style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
            <th style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[2].text}}</th>
          </tr>
        </thead>
      </template>
      <template slot="item" slot-scope="props">
        <tr>
          <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.proj_contract_sub_category }}</td>
          <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: right; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amount }}</td>
          <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
        </tr>
      </template>
    </v-data-table>
    <v-flex xs12>
      <table width="100%" cellpadding="0" cellspacing="0">
        <tbody>
          <tr style="color: #000;">
            <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">Sub Total</td>
            <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
              {{ handy.formatCur(projContractView[28][0].total_amount) }}
            </td>
            <td></td>
          </tr>
          <tr style="color: #000;">
            <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">Management fees</td>
            <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
              {{ handy.formatCur(projContractView[28][0].mgmt_fee) }}
            </td>
            <td></td>
          </tr>
          <tr style="background-color: #93f0cf; color:#09391f;">
            <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px; color:#09391f;">Total Before Tax</td>
            <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
              {{ handy.formatCur(projContractView[28][0].before_gst) }}
            </td>
            <td></td>
          </tr>
          <tr style="color: #000;">
            <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">GST</td>
            <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
              {{ handy.formatCur(projContractView[28].tax_amt) }}
            </td>
            <td></td>
          </tr>
          <tr style="background-color: #44cb82; color: #fff;">
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Grand Total with GST</td>
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
              {{ handy.formatCur(projContractView[28][0].total_amt) }}
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </v-flex>
  </v-flex>
</v-flex>
</v-layout>
</v-flex>
</v-card-text>
</v-card>
</v-flex>
</v-card-text>
<v-card-actions class="pt-0">
  <v-flex xs12>
    <v-tabs v-model="attTab" show-arrows>
      <v-tab v-for="(attitem, n) in viewTabItems" :key="n" :href="`#tab-${n}`" @click="changeView(attitem)">
        {{attitem}}
      </v-tab>
    </v-tabs>
  </v-flex>
</v-card-actions>
</v-card>
</v-dialog>

<!-- 7. TimeLine for showing the Details things of project contract -->
<v-dialog scrollable v-model="showTimelineInfo" max-width="700px">
  <v-flex xs12>
    <v-card flat>
      <v-card-title class="py-1 title grey lighten-4">
        <div>Timeline</div>
        <v-spacer></v-spacer>
        <v-btn small icon @click.stop="showTimelineInfo = false"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text>
        <v-timeline
        dense class="mt-2 pt-2"
        reverse
        >
        <v-timeline-item
        small right fill-dot
        icon="mdi-star" v-if="lProjContract.rejected_date"
        >
        <v-card class="elevation-2">
          <v-card-title class="subtitle-1 py-1 grey lighten-3">Rejected</v-card-title>
          <v-card-text class="pb-2 pt-1">
            Rejected by {{lProjContract.rejected_by_name}} on {{handy.formatDate(lProjContract.rejected_date)}} with remarks {{lProjContract.rejected_remark ? lProjContract.rejected_remark : '-'}}
          </v-card-text>
        </v-card>
      </v-timeline-item>
      <v-timeline-item
      small right fill-dot
      icon="mdi-star" v-if="lProjContract.approved_date"
      >
      <v-card class="elevation-2">
        <v-card-title class="subtitle-1 py-1 grey lighten-3">Approved</v-card-title>
        <v-card-text class="pb-2 pt-1">
          Approved by {{lProjContract.approved_by_name}} on {{handy.formatDate(lProjContract.approved_date)}} with remarks {{lProjContract.approved_remark ? lProjContract.approved_remark : '-'}}
        </v-card-text>
      </v-card>
    </v-timeline-item>
    <v-timeline-item
    small right fill-dot
    icon="mdi-star" v-if="lProjContract.submitted_date"
    >
    <v-card class="elevation-2">
      <v-card-title class="subtitle-1 py-1 grey lighten-3">Submitted</v-card-title>
      <v-card-text class="pb-2 pt-1">
        Submiited by {{lProjContract.submitted_by_name}} on {{handy.formatDate(lProjContract.submitted_date)}} with remarks {{lProjContract.submitted_remark ? lProjContract.submitted_remark : '-'}}
      </v-card-text>
    </v-card>
  </v-timeline-item>
  <v-timeline-item
  small right fill-dot
  icon="mdi-star" v-if="lProjContract.updated_date"
  >
  <v-card class="elevation-2">
    <v-card-title class="subtitle-1 py-1 grey lighten-3">Created</v-card-title>
    <v-card-text class="pb-2 pt-1">
      Created by {{lProjContract.update_by}} on {{handy.formatDate(lProjContract.updated_date)}}
    </v-card-text>
  </v-card>
</v-timeline-item>
<v-timeline-item
small right fill-dot
icon="mdi-star" v-if="lProjContract.files && lProjContract.files.length > 0"
>
<v-card class="elevation-2">
  <v-card-title class="subtitle-1 py-1 grey lighten-3">Attachments</v-card-title>
  <v-card-text class="pb-2 pt-1">
    <span v-if="lProjContract.files && lProjContract.files.filter(rec => rec.is_selected).length > 0">
      <span v-for="(file, index) in lProjContract.files.filter(rec => rec.is_selected)" :key="index">
        <v-chip v-model="file.is_selected">
          <span v-if="!file.is_changed">
            <a :href="handy.loadImg(file.file_url)" download style="text-decoration: none;">
              <v-btn small icon class="mr-1 info grey--text text--lighten-4">
                <v-icon small>mdi-download</v-icon>
              </v-btn>
            </a>
          </span>
          <span style="font-size: 12px;">{{ file.file_name }}</span>
        </v-chip>
      </span>
    </span>
  </v-card-text>
</v-card>
</v-timeline-item>
</v-timeline>
</v-card-text>
</v-card>
</v-flex>
</v-dialog>

<!-- snack bar for reporting -->
<v-snackbar :color="sbarCol" v-model="sbar"
:timeout="3000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>
</v-col>
</v-row>
</v-container>
</template>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'
var html2pdf = require('html2pdf.js')
import VDownloadAs from './VDownloadAs.vue'

export default {
  components:
  {
    'v-download-as': VDownloadAs
  },
  data () {
    return {
      // common
      sbarMsg: '',
      sbar: false,
      sbarCol: 'error',
      search: '',
      lAction: 'view',
      handy: handy,
      config: config,
      rules: handy.rules,
      isClosedProject: false,
      // Frontend
      selTab: 0,
      projTitle: [],
      projContHead: [
        { text:'Version No.', value:'version' },
        { text:'Status', value:'status' },
        { text:'Contract Start Date', value:'contract_start_date' },
        { text:'Contract End Date', value:'contract_end_date' },
        { text:'Total HC value', value: 'total_hc_value' },
        { text:'Mgmt fee', value:'Mgmt_fee' },
        { text:'Total Value', value:'total_value' },
        { text:'GST Amt', value:'gst_amt' },
        { text:'Contract Amt with Tax', value:'contract_amt_with_tax' },
      ],
      projContractList: [],
      // create or update project contract base
      lProjContractBase: [],
      lProjContract: {},
      projList: [],
      zoneList: [],
      totalContractAmt: {
        tot_contract_amt_with_gst: 0,
        tot_hc_amt: 0,
        amount: 0,
        mgmt_fee: 0,
        man_mgmt_fee: 0,
        tot_contract_amt: 0,
        tot_man_contract_amt: 0,
        gst_amt: 0,
        man_gst_amt: 0
      },
      // create or update project contract detail
      detHeaders: [
        { text: 'S No.', value: 'serial_no', width: '65px', class: 'pr-0 primary lighten-1 white--text' },
        { text: 'Service/ Role', value: 'staff_role', width: '140px', class: 'primary lighten-1 white--text' },
        { text: 'Tot HC', value: 'head_count', width: '70px', class: 'primary lighten-1 white--text', sortable: false },
        { text: 'Amt / HC', value: 'amt_per_hc', width: '100px', class: 'primary lighten-1 white--text', align: 'right', sortable: false },
        { text: 'Work hrs', value: 'work_hrs', width: '90px', class: 'primary lighten-1 white--text', sortable: false },
        { text: 'Tot HC value', value: 'total_hc_amt', width: '120px', class: 'primary lighten-1 white--text', align: 'right', sortable: false },
        { text: 'Contract start date', value: 'contract_start_date', width: '140px', class: 'primary lighten-1 white--text', sortable: false },
        { text: 'Contract end date', value: 'contract_end_date', width: '140px', class: 'primary lighten-1 white--text', sortable: false },
        { text: 'Mgmt %', value: 'Mgmt_fee_per', width: '80px', class: 'primary lighten-1 white--text', sortable: false },
        { text: 'Mgmt Fee', value: 'Mgmt_fee_amt', width: '100px', class: 'primary lighten-1 white--text', align: 'right', sortable: false },
        { text: 'GST Type', value: '', width: '85px', class: 'primary lighten-1 white--text', sortable: false },
        { text: 'GST %', value: 'tax_per', width: '80px', class: 'primary lighten-1 white--text', sortable: false },
        { text: 'GST Amt', value: 'tax_amt', width: '90px', class: 'primary lighten-1 white--text', align: 'right', sortable: false },
        { text: 'Grand Total', value: 'total_amt', width: '100px', class: 'primary lighten-1 white--text', align: 'right', sortable: false },
        { text: 'Is OS', value: 'is_os', width: '70px', class: 'primary lighten-1 white--text', sortable: false }
      ],
      serviceDetHeaders: [
        { text: 'S No.', value: 'serial_no', width: '65px', class: 'pr-0 primary lighten-1 white--text' },
        { text: 'Sub-Cat', value: 'proj_contract_sub_category', width: '150px', class: 'primary lighten-1 white--text' },
        { text: 'Amount', value: 'amount', width: '120px', class: 'primary lighten-1 white--text', align: 'right', sortable: false },
        { text: 'Contract start date', value: 'contract_start_date', width: '140px', class: 'primary lighten-1 white--text', sortable: false },
        { text: 'Contract end date', value: 'contract_end_date', width: '140px', class: 'primary lighten-1 white--text', sortable: false },
        { text: 'Mgmt %', value: 'Mgmt_fee_per', width: '80px', class: 'primary lighten-1 white--text', sortable: false },
        { text: 'Mgmt Fee', value: 'Mgmt_fee_amt', width: '100px', class: 'primary lighten-1 white--text', align: 'right', sortable: false },
        { text: 'GST Type', value: '', width: '85px', class: 'primary lighten-1 white--text', sortable: false },
        { text: 'GST %', value: 'tax_per', width: '80px', class: 'primary lighten-1 white--text', sortable: false },
        { text: 'GST Amt', value: 'tax_amt', width: '90px', class: 'primary lighten-1 white--text', align: 'right', sortable: false },
        { text: 'Grand Total', value: 'total_amt', width: '100px', class: 'primary lighten-1 white--text', align: 'right', sortable: false },
        { text: 'Is MR', value: 'is_monthly_rental', width: '70px', class: 'primary lighten-1 white--text', sortable: false },
        { text: 'Is OS', value: 'is_os', width: '70px', class: 'primary lighten-1 white--text', sortable: false }
      ],
      projContractDetList: [],
      projContractServiceDetList: [],
      detHistory: [
        { text: 'Revision History', value: 'version', class: 'primary lighten-1 white--text', sortable: false },
        { text: 'Contract Value', value: 'contract_value_with_gst', class: 'pl-0 pr-1 primary lighten-1 white--text', sortable: false }
      ],
      versionList: [],
      search: '',
      subcatList: [],
      // edit/create det form
      showDet: false,
      roleList: [],
      catList: [],
      lProjContractDet: [],
      lProjContractServiceDet: [],
      dlgPeriodFrom: false,
      dlgPeriodTo: false,
      dlgSPeriodFrom: false,
      dlgSPeriodTo: false,
      // changing the status
      showCommentDlg: false,
      lProjContractStatus: [],
      lVersion: '',
      lStatus: '',
      // subcat
      subCatList: [],
      showSubCat: false,
      subCatHeaders: [
        { text: 'Sub-Cat', value:'subCatHeaders', class: 'primary lighten-4' }
      ],
      showSubCatForm: false,
      lSubCat: [],
      // view
      projContractView: [],
      showViewAsPdf: false,
      techHeaders: [
        { text: 'Category' , value: 'proj_contract_sub_category' },
        { text: 'Total' , value: 'amount', sortable: false },
        { text: 'Comments' , value: 'comments', sortable: false }
      ],
      manpowerHeaders: [
        { text: 'Category' , value: 'staff_role' },
        { text: 'No of Person' , value: 'head_count' },
        { text: 'Rate/Person' , value: 'amt_per_hc' },
        { text: 'Total' , value: 'total_hc_amt' },
        { text: 'Comments' , value: 'comments' }
      ],
      category: ['MANAGEMENT/OFFICE', 'TECHNICAL SERVICES', 'SOFT SERVICES', 'OTHERS'],
      viewTabItems: ['Proposal breakup', 'end-to-end proposal', 'compressed view', 'M&S view'],
      isClosedProject: false,
      attTab: 'tab-0',
      // timeline
      showTimelineInfo: false,
      activeProjectApprovedContractExportHeader: [
        { text:'Project Id', value:'proj_id' },
        { text:'Project Name', value:'proj_name' },
        { text:'Role ID', value:'role_id' },
        { text:'Staff Role/ Service Name', value:'staff_role' },
        { text:'Role/ Service Category', value: 'role_cat' },
        { text:'Head Count', value:'head_count' },
        { text:'Work Hrs', value:'work_hrs' },
        { text:'Amount', value:'amt_per_hc' },
        { text:'Total HC  Amt', value:'total_hc_amt' },
        { text:'Mgmt Fee %', value:'Mgmt_fee_per' },
        { text:'Mgmt Fee Amt', value:'Mgmt_fee_amt' },
        { text:'Gst Type', value:'Gst_Type' },
        { text:'Gst %', value:'Gst_Per' },
        { text:'Gst Amt', value:'Gst_Amt' },
        { text:'Grand Total', value:'total_amt' },
        { text:'Is OS?', value:'is_os' },
        { text:'Contract Start Date', value:'contract_start_date' },
        { text:'Contract End Date', value:'contract_end_date' },
        { text:'Updated By', value:'updated_by' },
        { text:'Comments', value:'comments' },
        { text:'Community Id', value:'comm_id' },
        { text:'Vendor Id', value:'vendor_id' },
        { text:'Is Monthly Rental', value:'is_monthly_rental' },
        { text:'Rent Months', value:'months' }
      ],
      activeProjectApprovedContractExport: []
    }
  },
  created () {
    this.lProjContract = {}
    this.loadProjectContract()
    this.loadactiveProjectApprovedContractExport()
  },
  methods: {
    searchProjectTile (curRec) {
      if (curRec.length > 1) {
        var tmpVar = this.projTitle.filter(rec => rec.toLowerCase().includes(curRec.toLowerCase()))
        if (tmpVar.length > 0) {
          this.projTitle = []
          this.projTitle = tmpVar
        }
      } else {
        this.loadProjectContract()
      }
    },
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    prepareCreate () {
      this.lProjContractBase = {
        proj_pair: { proj_id: null, proj_name: '' },
        zone_id: null,
        status: null,
        version: null
      }
      this.projContractDetList = []
      this.lProjContractServiceDet = []
      this.firstTimeAddingDetails = true
      this.versionList = []
      this.lProjContract = {}
      this.totalContractAmt = {
        tot_contract_amt_with_gst: 0,
        tot_hc_amt: 0,
        amount: 0,
        mgmt_fee: 0,
        man_mgmt_fee: 0,
        tot_contract_amt: 0,
        tot_man_contract_amt: 0,
        gst_amt: 0,
        man_gst_amt: 0,
        tot_man_grand_total: 0,
        tot_ser_grand_total: 0
      }
      this.lStatus = 'Draft'
      this.lVersion = 1
      this.loadProjectList()
      this.lAction = 'create'
    },
    loadProjectList () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.projList = []
      this.axios.get(config.API_URL + '/getListOfProjectListBasedOnVendorId/', qry)
      .then(response => {
        this.projList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadZoneBasedOnPorjId (curProj) {
      var qry = {
        params: {
          proj_id: curProj.proj_pair.proj_id
        }
      }
      this.zoneList = []
      this.axios.get(config.API_URL + '/getZoneListBasedOnProjId/', qry)
      .then(response => {
        this.zoneList = response.data
        if (response.data.length) {
          this.lProjContractBase.zone_id = response.data[0].zone_id
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    saveProjectContractBaseChanges (action) {
      // validate and save Changes
      if (!this.lProjContractBase.proj_pair.proj_id) {
        this.msg('Please select the Project', 0)
      } else {
        if (this.$refs.pForm.validate()) {
          this.lProjContractBase.vendor_id = config.VENDOR_ID
          this.lProjContractBase.update_by = config.EMP_ID
          this.axios.post(config.API_URL + '/projectContractBase/' + action, this.lProjContractBase)
          .then(response => {
            this.lProjContractBase.proj_contract_base_id = response.data.proj_contract_base_id
            this.lProjContract.proj_contract_base_id = response.data.proj_contract_base_id
            this.lVersion = response.data.version
            this.lProjContractBase.proj_id = this.lProjContractBase.proj_pair.proj_id
            this.loadProjectList()
            this.lProjContractBase.proj_name = this.lProjContractBase.proj_pair.proj_name
            this.loadProjContractDet(this.lProjContractBase.proj_contract_base_id)
            this.loadVersionList(this.lProjContractBase.proj_pair.proj_id)
            this.msg('Saved Successfully', 1)
            this.lProjContract.det = "Manpower details"
            this.lAction = 'update'
          })
          .catch(err => {
            this.msg(err, 0)
            this.beingSaved = false
          })
        }
      }
    },
    loadVersionList (curProjId) {
      var qry = {
        params: {
          proj_id: curProjId
        }
      }
      this.versionList = []
      this.axios.get(config.API_URL + '/getListOfVersionsBasedOnProjId/', qry)
      .then(response => {
        this.versionList = response.data
        if (response.data.length > 0) {
          this.lProjContract.update_by = response.data.filter(rec => rec.proj_contract_base_id === this.lProjContract.proj_contract_base_id)[0].update_by_name
          this.lProjContract.updated_date = response.data.filter(rec => rec.proj_contract_base_id === this.lProjContract.proj_contract_base_id)[0].updated_date
          this.lProjContract.approved_by_name = response.data.filter(rec => rec.proj_contract_base_id === this.lProjContract.proj_contract_base_id)[0].approved_by_name
          this.lProjContract.approved_date = response.data.filter(rec => rec.proj_contract_base_id === this.lProjContract.proj_contract_base_id)[0].approved_date
          this.lProjContract.approved_remark = response.data.filter(rec => rec.proj_contract_base_id === this.lProjContract.proj_contract_base_id)[0].approve_remarks
          this.lProjContract.submitted_by_name = response.data.filter(rec => rec.proj_contract_base_id === this.lProjContract.proj_contract_base_id)[0].submitted_by_name
          this.lProjContract.submitted_date = response.data.filter(rec => rec.proj_contract_base_id === this.lProjContract.proj_contract_base_id)[0].submitted_date
          this.lProjContract.submitted_remark = response.data.filter(rec => rec.proj_contract_base_id === this.lProjContract.proj_contract_base_id)[0].submit_remarks
          this.lProjContract.rejected_date = response.data.filter(rec => rec.proj_contract_base_id === this.lProjContract.proj_contract_base_id)[0].rejected_date
          this.lProjContract.rejected_remark = response.data.filter(rec => rec.proj_contract_base_id === this.lProjContract.proj_contract_base_id)[0].rejected_remarks
          this.lProjContract.rejected_by_name = response.data.filter(rec => rec.proj_contract_base_id === this.lProjContract.proj_contract_base_id)[0].rejected_by_name
          this.lProjContract.drafted_date = response.data.filter(rec => rec.proj_contract_base_id === this.lProjContract.proj_contract_base_id)[0].drafted_date
          this.lProjContract.drafted_remark = response.data.filter(rec => rec.proj_contract_base_id === this.lProjContract.proj_contract_base_id)[0].drafted_remarks
          this.lProjContract.drafted_by_name = response.data.filter(rec => rec.proj_contract_base_id === this.lProjContract.proj_contract_base_id)[0].drafted_by
          this.lProjContract.tot_hc = this.versionList.filter(rec => rec.version === this.lVersion)[0].head_count
        }
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadProjContractDet (curBaseId) {
      var qry = {
        params: {
          proj_contract_base_id: curBaseId
        }
      }
      this.projContractDetList = []
      this.totalContractAmt = {
        tot_contract_amt_with_gst: 0,
        tot_hc_amt: 0,
        man_mgmt_fee: 0,
        tot_man_contract_amt: 0,
        man_gst_amt: 0,
        amount: 0,
        mgmt_fee: 0,
        tot_contract_amt: 0,
        gst_amt: 0,
        tot_man_grand_total: 0,
        tot_ser_grand_total: 0
      }
      this.axios.get(config.API_URL + '/getListOfContractDetailBasedonBaseId/', qry)
      .then(response => {
        if (response.data.length) {
          this.projContractDetList = response.data
          this.totalContractAmt.tot_hc_amt = response.data[response.data.length - 1].total_hc_amt
          this.totalContractAmt.man_mgmt_fee = response.data[response.data.length - 1].Mgmt_fee_amt
          this.totalContractAmt.man_gst_amt = response.data[response.data.length - 1].sgst_amt
          this.totalContractAmt.tot_man_contract_amt = this.totalContractAmt.tot_hc_amt + this.totalContractAmt.man_mgmt_fee
          this.totalContractAmt.tot_contract_amt_with_gst = response.data[response.data.length - 1].total_amt
          this.totalContractAmt.tot_man_grand_total = response.data[response.data.length - 1].total_amt
        } else {
          this.projContractDetList = []
        }
        if (this.projContractDetList.length === 0) {
          this.lProjContract.tot_hc = 0
        }
        this.loadProjContractServiceDet(curBaseId)
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadProjContractServiceDet (curBaseId) {
      var qry = {
        params: {
          proj_contract_base_id: curBaseId
        }
      }
      this.projContractServiceDetList = []
      this.axios.get(config.API_URL + '/getListOfContractServiceDetailBasedonBaseId/', qry)
      .then(response => {
        if (response.data.length) {
          this.projContractServiceDetList = response.data
          this.totalContractAmt.amount = response.data[response.data.length - 1].amount
          this.totalContractAmt.mgmt_fee = response.data[response.data.length - 1].Mgmt_fee_amt
          this.totalContractAmt.gst_amt = response.data[response.data.length - 1].sgst_amt
          this.totalContractAmt.tot_contract_amt += (this.totalContractAmt.amount + this.totalContractAmt.mgmt_fee)
          this.totalContractAmt.tot_contract_amt_with_gst += response.data[response.data.length - 1].total_amt
          this.totalContractAmt.tot_ser_grand_total = response.data[response.data.length - 1].total_amt
        } else {
          this.projContractServiceDetList = []
        }
        setTimeout(() => {
          if (this.projContractDetList.length === 0 && this.projContractServiceDetList.length === 0) {
            this.firstTimeAddingDetails = true
          } else {
            this.firstTimeAddingDetails = false
          }
        }, 500)
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadProjectContract () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          is_closed_project: this.isClosedProject
        }
      }
      this.axios.get(config.API_URL + '/getProjectContract/', qry)
      .then(response => {
        this.projContractList = response.data
        this.projTitle = handy.unique(this.projContractList.map(rec => rec.proj_name))
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareUpdate (curRec) {
      this.lProjContractBase = Object.assign({}, curRec)
      this.lProjContract.proj_contract_base_id = curRec.proj_contract_base_id
      this.lProjContractBase.proj_pair = { proj_id: curRec.proj_id, proj_name: curRec.proj_name }
      this.lProjContract.tot_hc = 0
      this.isClosedProject = curRec.proj_status === 'Closed' ? true : false
      this.lVersion = curRec.version
      this.lStatus = curRec.status
      this.lProjContract.det = "Manpower details"
      this.loadProjectList()
      this.loadVersionList(curRec.proj_id)
      this.loadProjContractDet(curRec.proj_contract_base_id)
      this.loadZoneBasedOnPorjId(this.lProjContractBase)
      this.loadProjectContractAttachments(curRec.proj_contract_base_id)
      this.lAction = 'update'
    },
    chooseToViewProjDet (curChip) {
      this.lProjContract.det = curChip
      this.loadProjContractDet(this.lProjContract.proj_contract_base_id)
      this.$forceUpdate()
    },
    prepareProjContractDet (curBaseId) {
      this.lProjContractDet = {
        role_id: null,
        head_count: null,
        amt_per_hc: null,
        total_hc_amt: null,
        work_hrs: null,
        is_os: false,
        contract_start_date: null,
        contract_end_date: null,
        Mgmt_fee_per: null,
        Mgmt_fee_amt: null,
        is_igst: '0',
        igst_per: 18,
        cgst_per: 9,
        sgst_per: 9,
        igst_amt: null,
        cgst_amt: null,
        sgst_amt: null,
        total_amt: null,
        proj_contract_base_id: curBaseId,
        updated_by: config.EMP_ID,
        action: 'Create',
        proj_contract_category_pair: {
          proj_contract_category: '',
          proj_contract_category_id: ''
        },
        comments: ''
      }
      this.lProjContractServiceDet = {
        amount: null,
        proj_contract_sub_cat_id: null,
        Mgmt_fee_per: null,
        Mgmt_fee_amt: null,
        is_igst: '0',
        igst_per: 18,
        cgst_per: 9,
        sgst_per: 9,
        igst_amt: null,
        cgst_amt: null,
        sgst_amt: null,
        total_amt: null,
        is_monthly_rental: 0,
        is_os: false,
        months: null,
        contract_start_date: null,
        contract_end_date: null,
        updated_by: config.EMP_ID,
        proj_contract_base_id: curBaseId,
        action: 'create',
        comments: ''
      }
      this.loadCategoryList()
      this.showDet = true
    },
    loadRolesorSubCatBasedOnCat (curPair) {
      if (curPair.proj_contract_category_id) {
        this.loadSubCatList(curPair.proj_contract_category_id)
      } else {
        this.loadRoleList()
      }
    },
    loadRoleList () {
      var qry = {
        params: {
          proj_id: this.lProjContractBase.proj_id,
          role_cat: this.lProjContractDet.proj_contract_category_pair.proj_contract_category
        }
      }
      this.roleList = []
      this.axios.get(config.API_URL + '/getListOfRoleBasedOnProjectId/', qry)
      .then(response => {
        this.roleList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadSubCatList (curCatId) {
      var qry = {
        params: {
          proj_contract_category_id: curCatId
        }
      }
      this.subcatList = []
      this.axios.get(config.API_URL + '/getListOfSubCatBasedOnCatId/', qry)
      .then(response => {
        this.subcatList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadCategoryList () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.catList = []
      this.axios.get(config.API_URL + '/getListOfCategoryBasedOnVendorId/', qry)
      .then(response => {
        this.catList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    calculateTotalHeadCountAmt () {
      if (this.lProjContractDet.head_count && this.lProjContractDet.amt_per_hc) {
        this.lProjContractDet.total_hc_amt = (this.lProjContractDet.head_count * this.lProjContractDet.amt_per_hc).toFixed(2)
      }
      if (this.lProjContractDet.total_hc_amt || this.lProjContractServiceDet.amount) {
        this.calculateTotalmgmtAmt()
      }
    },
    calculateTotalmgmtAmt () {
      if (this.lProjContractDet.total_hc_amt && (this.lProjContractDet.Mgmt_fee_per > -1)) {
        this.lProjContractDet.Mgmt_fee_amt = (this.lProjContractDet.total_hc_amt * (this.lProjContractDet.Mgmt_fee_per / 100)).toFixed(2)
        var tot_mgmt = Number(this.lProjContractDet.total_hc_amt) + Number(this.lProjContractDet.Mgmt_fee_amt)
        if (this.lProjContractDet.is_igst === '1') {
          this.lProjContractDet.cgst_amt = 0
          this.lProjContractDet.cgst_per = 0
          this.lProjContractDet.sgst_amt = 0
          this.lProjContractDet.sgst_per = 0
          this.lProjContractDet.igst_amt = (tot_mgmt * this.lProjContractDet.igst_per / 100).toFixed(2)
          this.lProjContractDet.total_amt = (Number(tot_mgmt) + Number(this.lProjContractDet.igst_amt)).toFixed(2)
        } else {
          this.lProjContractDet.is_igst = 0
          this.lProjContractDet.igst_amt = 0
          this.lProjContractDet.igst_per = 0
          this.lProjContractDet.cgst_amt = (tot_mgmt * this.lProjContractDet.cgst_per / 100).toFixed(2)
          this.lProjContractDet.sgst_amt = (tot_mgmt * this.lProjContractDet.sgst_per / 100).toFixed(2)
          this.lProjContractDet.total_amt = (Number(this.lProjContractDet.total_hc_amt) + Number(this.lProjContractDet.Mgmt_fee_amt) + Number(this.lProjContractDet.cgst_amt) + Number(this.lProjContractDet.sgst_amt)).toFixed(2)
        }
      }
      if (this.lProjContractServiceDet.amount) {
        this.lProjContractServiceDet.Mgmt_fee_amt = (this.lProjContractServiceDet.amount * (this.lProjContractServiceDet.Mgmt_fee_per / 100)).toFixed(2)
        var tot_service_mgmt = Number(this.lProjContractServiceDet.amount) + Number(this.lProjContractServiceDet.Mgmt_fee_amt)
        if (this.lProjContractServiceDet.is_igst === '1') {
          this.lProjContractServiceDet.cgst_amt = 0
          this.lProjContractServiceDet.cgst_per = 0
          this.lProjContractServiceDet.sgst_amt = 0
          this.lProjContractServiceDet.sgst_per = 0
          this.lProjContractServiceDet.igst_amt = (tot_service_mgmt * this.lProjContractServiceDet.igst_per / 100).toFixed(2)
          this.lProjContractServiceDet.total_amt = (tot_service_mgmt + Number(this.lProjContractServiceDet.igst_amt)).toFixed(2)
        } else {
          this.lProjContractServiceDet.is_igst = 0
          this.lProjContractServiceDet.igst_amt = 0
          this.lProjContractServiceDet.igst_per = 0
          this.lProjContractServiceDet.cgst_amt = (tot_service_mgmt * (this.lProjContractServiceDet.cgst_per / 100)).toFixed(2)
          this.lProjContractServiceDet.sgst_amt = (tot_service_mgmt * (this.lProjContractServiceDet.sgst_per / 100)).toFixed(2)
          this.lProjContractServiceDet.total_amt = (tot_service_mgmt + Number(this.lProjContractServiceDet.cgst_amt) + Number(this.lProjContractServiceDet.sgst_amt)).toFixed(2)
        }
      }
    },
    async saveStaffDetail (action) {
      // validate and save Changes
      if (!this.lProjContractDet.role_id || !this.lProjContractDet.head_count || !this.lProjContractDet.amt_per_hc || !this.lProjContractDet.contract_start_date || !this.lProjContractDet.contract_end_date) {
        this.msg('Please Enter all the fields', 0)
      } else {
        if (this.$refs.dForm.validate()) {
          await this.axios.post(config.API_URL + '/projectContractDetail/' + action, this.lProjContractDet)
          .then(response => {
            if (response.data === 'success') {
              this.showDet = false
              this.lProjContractDet.action = 'View'
              this.loadProjContractDet(this.lProjContract.proj_contract_base_id)
              this.loadVersionList(this.lProjContractBase.proj_id)
              this.loadProjectContract()
              this.msg('Saved Successfully', 1)
            } else {
              this.msg(response.data, 0)
            }
          })
          .catch(err => {
            this.msg(err, 0)
          })
        }
      }
    },
    async saveServiceDetail (action) {
      // validate and save Changes
      if (!this.lProjContractServiceDet.proj_contract_sub_cat_id || !this.lProjContractServiceDet.amount || !this.lProjContractServiceDet.contract_start_date || !this.lProjContractServiceDet.contract_end_date) {
        this.msg('Please Enter all the fields', 0)
      } else {
        if (this.$refs.sForm.validate()) {
          this.axios.post(config.API_URL + '/projectContractServiceDetail/' + action, this.lProjContractServiceDet)
          .then(response => {
            if (response.data === 'success') {
              this.serviceGSTOverride = false
              this.showDet = false
              this.loadProjContractDet(this.lProjContractServiceDet.proj_contract_base_id)
              this.loadVersionList(this.lProjContractBase.proj_id)
              this.loadProjectContract()
              this.msg('Saved Successfully', 1)
            } else {
              this.msg(response.data, 0)
            }
          })
          .catch(err => {
            this.msg(err, 0)
          })
        }
      }
    },
    prepareUpdateProjContractDet (curDetRec) {
      this.lProjContractDet = Object.assign({}, curDetRec)
      this.lProjContractDet.contract_start_date = handy.formatDBDate(curDetRec.contract_start_date)
      this.lProjContractDet.contract_end_date = handy.formatDBDate(curDetRec.contract_end_date)
      this.lProjContractDet.proj_contract_base_id = this.lProjContract.proj_contract_base_id
      this.lProjContractDet.proj_contract_category_pair = { proj_contract_category: curDetRec.role_cat, proj_contract_category_id: null }
      this.lProjContractDet.is_igst = curDetRec.is_igst === 1 ? '1' : '0'
      this.lProjContractDet.updated_by = config.EMP_ID
      this.lProjContractDet.action = 'Update'
      this.loadRoleList()
      this.loadCategoryList()
      this.showDet = true
    },
    prepareUpdateProjContractServiceDet (curDetRec) {
      this.lProjContractServiceDet = Object.assign({}, curDetRec)
      this.lProjContractServiceDet.contract_start_date = handy.formatDBDate(curDetRec.contract_start_date)
      this.lProjContractServiceDet.contract_end_date = handy.formatDBDate(curDetRec.contract_end_date)
      this.lProjContractServiceDet.proj_contract_base_id = this.lProjContract.proj_contract_base_id
      this.lProjContractServiceDet.updated_by = config.EMP_ID
      this.lProjContractServiceDet.action = 'Update'
      this.lProjContractDet.proj_contract_category_pair = { proj_contract_category: curDetRec.proj_contract_category, proj_contract_category_id: curDetRec.proj_contract_category_id }
      this.lProjContractServiceDet.is_igst = curDetRec.is_igst === 1 ? '1' : '0'
      this.lProjContractServiceDet.is_igst = curDetRec.is_os === null ? 0 : curDetRec.is_os
      this.showDet = true
      this.loadSubCatList(curDetRec.proj_contract_category_id)
    },
    deleteDetail (curDetRec) {
      if (!confirm('Sure, you want to delete the Manpower Details with role name "' + curDetRec.staff_role + '"?')) {
        return
      }
      // up in db
      this.axios.post(config.API_URL + '/projectContractDetail/delete', curDetRec)
      .then(response => {
        // refresh stats
        this.loadProjContractDet(this.lProjContract.proj_contract_base_id)
        this.loadVersionList(this.lProjContractBase.proj_id)
        this.loadProjectContract()
        curDetRec.action = 'view'
        this.showDet = false
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    deleteServiceDetail (curDetRec) {
      if (!confirm('Sure, you want to delete the Service Details with Sub-cat "' + curDetRec.proj_contract_sub_category + '"?')) {
        return
      }
      // up in db
      this.axios.post(config.API_URL + '/projectContractServiceDetail/delete', curDetRec)
      .then(response => {
        // refresh stats
        this.loadProjContractDet(this.lProjContract.proj_contract_base_id)
        this.loadVersionList(this.lProjContractBase.proj_id)
        this.loadProjectContract()
        curDetRec.action = 'view'
        this.showDet = false
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareCloneProjectContract (curDetRec) {
      this.lProjContractDet = Object.assign({}, curDetRec)
      this.lProjContractDet.head_count = null
      this.lProjContractDet.amt_per_hc = null
      this.lProjContractDet.total_hc_amt = null
      this.lProjContractDet.Mgmt_fee_amt = null
      this.lProjContractDet.cgst_amt = null
      this.lProjContractDet.sgst_amt = null
      this.lProjContractDet.igst_amt = null
      this.lProjContractDet.total_amt = null
      this.lProjContractDet.role_id = null
      this.lProjContractDet.comments = ''
      this.lProjContractDet.proj_contract_category_pair = { proj_contract_category: curDetRec.role_cat, proj_contract_category_id: null }
      this.lProjContractDet.contract_start_date = handy.formatDBDate(curDetRec.contract_start_date)
      this.lProjContractDet.contract_end_date = handy.formatDBDate(curDetRec.contract_end_date)
      this.lProjContractDet.proj_contract_base_id = this.lProjContract.proj_contract_base_id
      this.lProjContractDet.updated_by = config.EMP_ID
      this.lProjContractDet.is_igst = curDetRec.is_igst === 1 ? '1' : '0'
      this.lProjContractDet.action = 'Create'
      this.showDet = true
      this.loadRoleList()
      this.loadCategoryList()
    },
    prepareCloneProjectContractService (curDetRec) {
      this.lProjContractServiceDet = Object.assign({}, curDetRec)
      this.lProjContractServiceDet.amount = null
      this.lProjContractServiceDet.Mgmt_fee_amt = null
      this.lProjContractServiceDet.cgst_amt = null
      this.lProjContractServiceDet.sgst_amt = null
      this.lProjContractServiceDet.igst_amt = null
      this.lProjContractServiceDet.total_amt = null
      this.lProjContractServiceDet.proj_contract_sub_cat_id = null
      this.lProjContractServiceDet.comments = ''
      this.lProjContractDet.proj_contract_category_pair = { proj_contract_category: curDetRec.proj_contract_category, proj_contract_category_id: curDetRec.proj_contract_category_id }
      this.lProjContractServiceDet.contract_start_date = handy.formatDBDate(curDetRec.contract_start_date)
      this.lProjContractServiceDet.contract_end_date = handy.formatDBDate(curDetRec.contract_end_date)
      this.lProjContractServiceDet.proj_contract_base_id = this.lProjContract.proj_contract_base_id
      this.lProjContractServiceDet.updated_by = config.EMP_ID
      this.lProjContractServiceDet.is_igst = curDetRec.is_igst === 1 ? '1' : '0'
      this.lProjContractServiceDet.action = 'create'
      this.showDet = true
      this.loadCategoryList()
      this.loadSubCatList(curDetRec.proj_contract_category_id)
    },
    viewServiceDetail (curDetRec) {
      this.lProjContractServiceDet = Object.assign({}, curDetRec)
      this.lProjContractServiceDet.action = 'view'
      this.lProjContractServiceDet.is_igst = curDetRec.is_igst === 1 ? '1' : '0'
      this.lProjContractServiceDet.contract_start_date = handy.formatDBDate(curDetRec.contract_start_date)
      this.lProjContractServiceDet.contract_end_date = handy.formatDBDate(curDetRec.contract_end_date)
      this.lProjContractDet.proj_contract_category_pair = { proj_contract_category: curDetRec.proj_contract_category, proj_contract_category_id: curDetRec.proj_contract_category_id }
      this.showDet = true
      this.loadCategoryList()
      this.loadSubCatList(curDetRec.proj_contract_category_id)
    },
    viewStaffDetail (curDetRec) {
      this.lProjContractDet = Object.assign({}, curDetRec)
      this.lProjContractDet.action = 'View'
      this.lProjContractDet.is_igst = curDetRec.is_igst === 1 ? '1' : '0'
      this.lProjContractDet.contract_start_date = handy.formatDBDate(curDetRec.contract_start_date)
      this.lProjContractDet.contract_end_date = handy.formatDBDate(curDetRec.contract_end_date)
      this.lProjContractDet.proj_contract_category_pair = { proj_contract_category: curDetRec.role_cat, proj_contract_category_id: null }
      this.showDet = true
      this.loadRoleList()
      this.loadCategoryList()
    },
    deleteProjectContract (curContract) {
      if (!confirm('Sure, you want to delete the Project Contract with name "' + curContract.proj_name + '" and Ver "' + this.lVersion +'.0" (' + this.lStatus +') ?')) {
        return
      }
      // up in db
      curContract.vendor_id = config.VENDOR_ID
      curContract.proj_contract_base_id = this.lProjContract.proj_contract_base_id
      this.axios.post(config.API_URL + '/projectContractBase/delete', curContract)
      .then(response => {
        // refresh stats
        this.loadProjectContract()
        this.lAction = 'view'
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareProjectContractStatus (curBase, status) {
      this.lProjContractStatus = Object.assign({}, curBase)
      this.lProjContractStatus.approve_remarks = ''
      this.lProjContractStatus.submit_remarks = ''
      this.lProjContractStatus.rejected_remark = ''
      this.lProjContractStatus.drafted_remarks = ''
      this.lProjContractStatus.status = status
      this.showCommentDlg = true
    },
    statusChangeTheProjectContract (curBase, status) {
      var tot_igst = 0
      var tot_cgst = 0
      this.projContractDetList.forEach(async rec => {
        if (rec.is_igst) {
          tot_igst++
        } else if (rec.is_igst === 0) {
          tot_cgst++
        }
      })
      this.projContractServiceDetList.forEach(async rec => {
        if (rec.is_igst) {
          tot_igst++
        } else if (rec.is_igst === 0) {
          tot_cgst++
        }
      })
      if (tot_igst > 0 && tot_cgst > 0) {
        if(!confirm('There are CGST & IGST records are found. Do you want to proceed?')) {
          return
        }
      }
      var idx = -1
      if (status === "Submitted") {
        idx = this.versionList.findIndex(rec => rec.status === status)
      }
      if (idx > -1) {
        this.msg('Only one Submitted version is allowed for one Project Contract', 0)
      } else {
        if (!confirm('Sure, you want to change the Status to "' + status + ' ?"')) {
          return
        }
        // up in db
        curBase.vendor_id = config.VENDOR_ID
        curBase.status = status
        if (status === 'Submitted') {
          curBase.submitted_by = config.EMP_ID
          curBase.approved_by = null
          curBase.approved_date = null
        } else if (status === 'Approved') {
          curBase.approved_by = config.EMP_ID
        } else if (status === "Draft") {
          curBase.drafted_by = config.EMP_ID
        } else {
          curBase.rejected_by = config.EMP_ID
        }
        curBase.proj_contract_base_id = this.lProjContract.proj_contract_base_id
        this.axios.post(config.API_URL + '/projectContractBase/status', curBase)
        .then(response => {
          this.lProjContractDet.action = 'View'
          if (status === "Rejected") {
            this.lStatus = "Draft"
          } else {
            this.lStatus = status
          }
          this.loadProjContractDet(curBase.proj_contract_base_id)
          this.loadVersionList(curBase.proj_id)
          this.loadProjectContract()
          this.msg('Saved Successfully', 1)
          this.showCommentDlg = false
        })
        .catch(err => {
          this.msg(err, 0)
        })
      }
    },
    loadManPowerBasedOnVersion (curRec) {
      this.lVersion = curRec.version
      this.lStatus = curRec.status
      this.lProjContract.tot_hc = curRec.head_count
      this.lProjContract.update_by = curRec.update_by_name
      this.lProjContract.updated_date = curRec.updated_date
      this.lProjContract.approved_by_name = curRec.approved_by_name
      this.lProjContract.rejected_by_name = curRec.rejected_by_name
      this.lProjContract.submitted_by_name = curRec.submitted_by_name
      this.lProjContract.submitted_date = curRec.submitted_date
      this.lProjContract.approved_date = curRec.approved_date
      this.lProjContract.rejected_date = curRec.rejected_date
      this.lProjContract.proj_contract_base_id = curRec.proj_contract_base_id
      this.loadProjContractDet(curRec.proj_contract_base_id)
      this.loadProjectContractAttachments(curRec.proj_contract_base_id)
    },
    prepareRevision (curRec) {
      // call store procedure
      curRec.emp_id = config.EMP_ID
      curRec.vendor_id = config.VENDOR_ID
      curRec.proj_id = this.lProjContractBase.proj_id
      this.axios.post(config.API_URL + '/projectContractDetail/projContractRevision', curRec)
      .then(response => {
        this.lProjContractBase.proj_contract_base_id = response.data.proj_contract_base_id
        this.lProjContractBase.proj_id = response.data.proj_id
        this.lProjContract.proj_contract_base_id = this.lProjContractBase.proj_contract_base_id
        this.lStatus = response.data.status
        this.lVersion = response.data.version
        this.lProjContract.submitted_by_name = ''
        this.loadProjContractDet(this.lProjContractBase.proj_contract_base_id)
        this.loadVersionList(this.lProjContractBase.proj_id)
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareSubCat (curCatId) {
      var qry = {
        params: {
          proj_contract_category_id: curCatId
        }
      }
      this.axios.get(config.API_URL + '/getListOfSubCat/', qry)
      .then(response => {
        this.subCatList = response.data
        this.showSubCat = true
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareSubCatItems (curCatId) {
      this.lSubCat = {
        proj_contract_category_id: curCatId,
        proj_contract_sub_category: '',
        action: 'create'
      }
      this.showSubCatForm = true
    },
    saveSubCat (action) {
      // validate and save Changes
      if (this.$refs.cForm.validate()) {
        if (action === 'delete') {
          if (!confirm('Sure, you want to delete the Sub-cat "' + this.lSubCat.proj_contract_sub_category + '"?')) {
            return
          }
        }
        this.axios.post(config.API_URL + '/projectContractSubCat/' + action, this.lSubCat)
        .then(response => {
          if (action === 'create' && response.data === 'Sub-category with same name is already exists') {
            this.msg(response.data, 0)
          } else {
            this.showSubCatForm = false
            if (action === 'delete') {
              this.msg('Deleted Successfully', 1)
              this.loadSubCatList(this.lSubCat.proj_contract_category_id)
            } else {
              this.lSubCat.proj_contract_sub_category_id = response.data
              this.msg('Saved Successfully', 1)
              this.loadSubCatList(this.lSubCat.proj_contract_category_id)
            }
          }
        })
        .catch(err => {
          this.msg(err, 0)
        })
      }
    },
    prepareUpdateSubCat (curRec) {
      this.lSubCat = Object.assign({}, curRec)
      this.lSubCat.action = 'update'
      this.showSubCatForm = true
    },
    prepareViewProjContract (curContract) {
      var qry = {
        params: {
          proj_contract_base_id: curContract.proj_contract_base_id
        }
      }
      this.axios.get(config.API_URL + '/getProjContractViewAsPdf/', qry)
      .then(response => {
        this.projContractView = response.data
        this.projContractView.forEach(rec => {
          if (rec.length) {
            if (!rec.total_amount) {
              rec.total_amount = 0
            }
            if (!rec.gst_amt || !rec.before_gst) {
              rec.gst_tax_amt = 0
              rec.tax_amt = 0
              rec.before_gst = 0
            }
            if (!rec.mgmt) {
              rec.mgmt = 0
            }
            rec.forEach(records => {
              if (records.amount) {
                rec.total_amount += records.amount
              }
              if (records.total_hc_amt) {
                rec.total_amount += records.total_hc_amt
              }
              rec.mgmt += records.Mgmt_fee_amt
              rec.tax_amt += records.tax_amt
              rec.before_gst = rec.total_amount + rec.mgmt
              rec.gst_tax_amt = rec.before_gst + rec.tax_amt
            })
          }
        })
        this.showViewAsPdf = true
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    downloadAsPdf () {
      // pdf options
      let opt = {
        margin: 9,
        filename: 'projectContract.pdf',
        image: { type: 'jpeg', quality: 0.95 },
        html2canvas: { scale: 2.5, dpi: 120, letterRendering: true, width: 747 },
        jsPDF: { format: 'letter' },
        pagebreak: { mode: ['avoid-all', 'legacy'] }
      }

      var canvas = document.getElementById('pdf_report')
      html2pdf().from(canvas).set(opt).toPdf().get('pdf').then(function (pdf) {
        var totalPages = pdf.internal.getNumberOfPages()

        for (var i = 1; i <= totalPages; i++) {
          pdf.setPage(i)
          pdf.setFontSize(8)
          pdf.text('Page ' + i + ' of ' + totalPages, pdf.internal.pageSize.getWidth() - 25, pdf.internal.pageSize.getHeight() - 5)
        }
      }).save()
    },
    changeView (curTab) {
      if (curTab === 'Proposal breakup') {
        this.attTab = 'tab-0'
      } else if (curTab === 'end-to-end proposal') {
        this.attTab = 'tab-1'
      } else if (curTab === 'compressed view') {
        this.attTab = 'tab-2'
      } else {
        this.attTab = 'tab-3'
      }
    },
    showClosedProjects () {
      this.isClosedProject = !this.isClosedProject
      this.loadProjectContract()
    },
    pickFile () {
      this.$refs.fileInput.click()
    },
    loadFilesFromFileBrowser (curProject) {
      let currentDate = new Date()
      let time = currentDate.getHours() + "-" + currentDate.getMinutes() + "-" + currentDate.getSeconds()
      const files = event.target.files
      if (!curProject.files) {
        curProject.files = []
      }
      Array.from(files).forEach((file) => {
        const fileReader = new FileReader()
        const getResult = new Promise(resolve => {
          fileReader.onload = e => {
            curProject.files.push({
              file_url: e.target.result.split(',')[1],
              file_name: file.name.split('.')[0] + '_' + handy.formatDBDate(currentDate) + '_' + time + '.' + file.name.split('.')[1],
              is_selected: true,
              is_changed: true
            })
            this.$forceUpdate()
          }
        })
        fileReader.readAsDataURL(file)
        return getResult.then(file => {
          return file
        })
      })
    },
    removeSelectedFile (curFile) {
      curFile.is_selected = false
      this.$forceUpdate()
    },
    saveProjectContractAttachment () {
      this.lProjContract.vendor_id = config.VENDOR_ID
      this.lProjContract.proj_id = this.lProjContractBase.proj_id
      this.lProjContract.version = this.lVersion
      this.lProjContract.proj_contract_base_id = this.lProjContractBase.proj_contract_base_id
      this.axios.post(config.API_URL + '/projectContractBase/attach', this.lProjContract)
      .then(response => {
        this.msg('Saved Successfully', 1)
        this.loadProjectContractAttachments(this.lProjContractBase.proj_contract_base_id)
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadProjectContractAttachments (curBaseId) {
      var path = require('path')
      var qry = {
        params: {
          proj_contract_base_id: curBaseId,
          vendor_id: config.VENDOR_ID
        }
      }
      this.lProjContract.files = []
      this.axios.get(config.API_URL + '/getProjectContractAttachmentsBasedOnBaseId/', qry)
      .then(response => {
        response.data.forEach((rec) => {
          this.lProjContract.files.push({
            file_url: rec.file_url,
            file_name: rec.file_url ? path.basename(rec.file_url) : '',
            is_selected: true,
            is_changed: false
          })
        })
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadactiveProjectApprovedContractExport () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.activeProjectApprovedContractExport = []
      this.axios.get(config.API_URL + '/getAllProjectContractDetails/', qry)
      .then(response => {
        this.activeProjectApprovedContractExport = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    }
  }
}
</script>
